/* Zepto v1.2.0 - zepto event ajax form ie - zeptojs.com/license */
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}
// Полифилл isInteger
Number.isInteger = Number.isInteger || function (value) {
    return typeof value === 'number' &&
        isFinite(value) &&
        Math.floor(value) === value;
};
// Полифилл closest
(function () {
    if (!Element.prototype.closest) {
        Element.prototype.closest = function (css) {
            var node = this;
            while (node) {
                if (node.matches(css)) return node;
                else node = node.parentElement;
            }
            return null;
        };
    }
})();
// Полифилл classList.toggle
; (function () {
    var regExp = function (name) {
        return new RegExp('(^| )' + name + '( |$)');
    };
    var forEach = function (list, fn, scope) {
        for (var i = 0; i < list.length; i++) {
            fn.call(scope, list[i]);
        }
    };
    function ClassList(element) {
        this.element = element;
    }
    ClassList.prototype = {
        add: function () {
            forEach(arguments, function (name) {
                if (!this.contains(name)) {
                    this.element.className += ' ' + name;
                }
            }, this);
        },
        remove: function () {
            forEach(arguments, function (name) {
                this.element.className =
                    this.element.className.replace(regExp(name), '');
            }, this);
        },
        toggle: function (name) {
            return this.contains(name)
                ? (this.remove(name), false) : (this.add(name), true);
        },
        contains: function (name) {
            return regExp(name).test(this.element.className);
        },
        replace: function (oldName, newName) {
            this.remove(oldName), this.add(newName);
        }
    };
    if (!('classList' in Element.prototype)) {
        Object.defineProperty(Element.prototype, 'classList', {
            get: function () {
                return new ClassList(this);
            }
        });
    }
    if (window.DOMTokenList && DOMTokenList.prototype.replace == null) {
        DOMTokenList.prototype.replace = ClassList.prototype.replace;
    }
})();
// Полифилл toggleAttribute
if (!Element.prototype.toggleAttribute) {
    Element.prototype.toggleAttribute = function (name, force) {
        if (force !== void 0) force = !!force

        if (this.hasAttribute(name)) {
            if (force) return true;

            this.removeAttribute(name);
            return false;
        }
        if (force === false) return false;

        this.setAttribute(name, "");
        return true;
    };
}
(function (global, factory) {
    if (typeof define === 'function' && define.amd)
        define(function () { return factory(global) })
    else
        factory(global)
}(this, function (window) {
    var Zepto = (function () {
        var undefined, key, $, emptyArray = [], concat = emptyArray.concat, filter = emptyArray.filter, slice = emptyArray.slice,
            document = window.document,
            //   elementDisplay = {},
            //   cssNumber = { 'column-count': 1, 'columns': 1, 'font-weight': 1, 'line-height': 1, 'opacity': 1, 'z-index': 1, 'zoom': 1 },
            fragmentRE = /^\s*<(\w+|!)[^>]*>/,
            singleTagRE = /^<(\w+)\s*\/?>(?:<\/\1>|)$/,
            tagExpanderRE = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/ig,

            // special attributes that should be get/set via method calls
            methodAttributes = ['val', 'css', 'html', 'text', 'data', 'width', 'height', 'offset'],

            adjacencyOperators = ['after', 'prepend', 'before', 'append'],
            table = document.createElement('table'),
            tableRow = document.createElement('tr'),
            containers = {
                'tr': document.createElement('tbody'),
                'tbody': table, 'thead': table, 'tfoot': table,
                'td': tableRow, 'th': tableRow,
                '*': document.createElement('div')
            },
            readyRE = /complete|loaded|interactive/,
            simpleSelectorRE = /^[\w-]*$/,
            class2type = {},
            toString = class2type.toString,
            zepto = {},
            camelize, uniq,
            tempParent = document.createElement('div'),
            isArray = Array.isArray ||
                function (object) { return object instanceof Array }

        zepto.matches = function (element, selector) {
            if (!selector || !element || element.nodeType !== 1) return false
            var matchesSelector = element.matches || element.webkitMatchesSelector ||
                element.mozMatchesSelector || element.oMatchesSelector ||
                element.matchesSelector
            if (matchesSelector) return matchesSelector.call(element, selector)
            // fall back to performing a selector:
            var match, parent = element.parentNode, temp = !parent
            if (temp) (parent = tempParent).appendChild(element)
            match = ~zepto.qsa(parent, selector).indexOf(element)
            temp && tempParent.removeChild(element)
            return match
        }

        function type(obj) {
            return obj == null ? String(obj) :
                class2type[toString.call(obj)] || "object"
        }

        function isFunction(value) { return type(value) == "function" }
        function isWindow(obj) { return obj != null && obj == obj.window }
        function isDocument(obj) { return obj != null && obj.nodeType == obj.DOCUMENT_NODE }
        function isObject(obj) { return type(obj) == "object" }
        function isPlainObject(obj) {
            return isObject(obj) && !isWindow(obj) && Object.getPrototypeOf(obj) == Object.prototype
        }

        function likeArray(obj) {
            var length = !!obj && 'length' in obj && obj.length,
                type = $.type(obj)

            return 'function' != type && !isWindow(obj) && (
                'array' == type || length === 0 ||
                (typeof length == 'number' && length > 0 && (length - 1) in obj)
            )
        }

        function compact(array) { return filter.call(array, function (item) { return item != null }) }
        function flatten(array) { return array.length > 0 ? $.fn.concat.apply([], array) : array }
        camelize = function (str) { return str.replace(/-+(.)?/g, function (match, chr) { return chr ? chr.toUpperCase() : '' }) }
        function dasherize(str) {
            return str.replace(/::/g, '/')
                .replace(/([A-Z]+)([A-Z][a-z])/g, '$1_$2')
                .replace(/([a-z\d])([A-Z])/g, '$1_$2')
                .replace(/_/g, '-')
                .toLowerCase()
        }
        uniq = function (array) { return filter.call(array, function (item, idx) { return array.indexOf(item) == idx }) }

        function Z(dom, selector) {
            var i, len = dom ? dom.length : 0
            for (i = 0; i < len; i++) this[i] = dom[i]
            this.length = len
            this.selector = selector || ''
        }

        // `$.zepto.fragment` takes a html string and an optional tag name
        // to generate DOM nodes from the given html string.
        // The generated DOM nodes are returned as an array.
        // This function can be overridden in plugins for example to make
        // it compatible with browsers that don't support the DOM fully.
        zepto.fragment = function (html, name, properties) {
            var dom, nodes, container

            // A special case optimization for a single tag
            if (singleTagRE.test(html)) dom = $(document.createElement(RegExp.$1))

            if (!dom) {
                if (html.replace) html = html.replace(tagExpanderRE, "<$1></$2>")
                if (name === undefined) name = fragmentRE.test(html) && RegExp.$1
                if (!(name in containers)) name = '*'

                container = containers[name]
                container.innerHTML = '' + html
                dom = $.each(slice.call(container.childNodes), function () {
                    container.removeChild(this)
                })
            }

            if (isPlainObject(properties)) {
                nodes = $(dom)
                $.each(properties, function (key, value) {
                    if (methodAttributes.indexOf(key) > -1) nodes[key](value)
                    else nodes.attr(key, value)
                })
            }

            return dom
        }

        // `$.zepto.Z` swaps out the prototype of the given `dom` array
        // of nodes with `$.fn` and thus supplying all the Zepto functions
        // to the array. This method can be overridden in plugins.
        zepto.Z = function (dom, selector) {
            return new Z(dom, selector)
        }

        // `$.zepto.isZ` should return `true` if the given object is a Zepto
        // collection. This method can be overridden in plugins.
        zepto.isZ = function (object) {
            return object instanceof zepto.Z
        }

        // `$.zepto.init` is Zepto's counterpart to jQuery's `$.fn.init` and
        // takes a CSS selector and an optional context (and handles various
        // special cases).
        // This method can be overridden in plugins.
        zepto.init = function (selector, context) {
            var dom
            // If nothing given, return an empty Zepto collection
            if (!selector) return zepto.Z()
            // Optimize for string selectors
            else if (typeof selector == 'string') {
                selector = selector.trim()
                // If it's a html fragment, create nodes from it
                // Note: In both Chrome 21 and Firefox 15, DOM error 12
                // is thrown if the fragment doesn't begin with <
                if (selector[0] == '<' && fragmentRE.test(selector))
                    dom = zepto.fragment(selector, RegExp.$1, context), selector = null
                // If there's a context, create a collection on that context first, and select
                // nodes from there
                else if (context !== undefined) return $(context).find(selector)
                // If it's a CSS selector, use it to select nodes.
                else dom = zepto.qsa(document, selector)
            }
            // If a function is given, call it when the DOM is ready
            else if (isFunction(selector)) return $(document).ready(selector)
            // If a Zepto collection is given, just return it
            else if (zepto.isZ(selector)) return selector
            else {
                // normalize array if an array of nodes is given
                if (isArray(selector)) dom = compact(selector)
                // Wrap DOM nodes.
                else if (isObject(selector))
                    dom = [selector], selector = null
                // If it's a html fragment, create nodes from it
                else if (fragmentRE.test(selector))
                    dom = zepto.fragment(selector.trim(), RegExp.$1, context), selector = null
                // If there's a context, create a collection on that context first, and select
                // nodes from there
                else if (context !== undefined) return $(context).find(selector)
                // And last but no least, if it's a CSS selector, use it to select nodes.
                else dom = zepto.qsa(document, selector)
            }
            // create a new Zepto collection from the nodes found
            return zepto.Z(dom, selector)
        }

        // `$` will be the base `Zepto` object. When calling this
        // function just call `$.zepto.init, which makes the implementation
        // details of selecting nodes and creating Zepto collections
        // patchable in plugins.
        $ = function (selector, context) {
            return zepto.init(selector, context)
        }

        function extend(target, source, deep) {
            for (key in source)
                if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
                    if (isPlainObject(source[key]) && !isPlainObject(target[key]))
                        target[key] = {}
                    if (isArray(source[key]) && !isArray(target[key]))
                        target[key] = []
                    extend(target[key], source[key], deep)
                }
                else if (source[key] !== undefined) target[key] = source[key]
        }

        // Copy all but undefined properties from one or more
        // objects to the `target` object.
        $.extend = function (target) {
            var deep, args = slice.call(arguments, 1)
            if (typeof target == 'boolean') {
                deep = target
                target = args.shift()
            }
            args.forEach(function (arg) { extend(target, arg, deep) })
            return target
        }

        // `$.zepto.qsa` is Zepto's CSS selector implementation which
        // uses `document.querySelectorAll` and optimizes for some special cases, like `#id`.
        // This method can be overridden in plugins.
        zepto.qsa = function (element, selector) {
            var found,
                maybeID = selector[0] == '#',
                maybeClass = !maybeID && selector[0] == '.',
                nameOnly = maybeID || maybeClass ? selector.slice(1) : selector, // Ensure that a 1 char tag name still gets checked
                isSimple = simpleSelectorRE.test(nameOnly)
            return (element.getElementById && isSimple && maybeID) ? // Safari DocumentFragment doesn't have getElementById
                ((found = element.getElementById(nameOnly)) ? [found] : []) :
                (element.nodeType !== 1 && element.nodeType !== 9 && element.nodeType !== 11) ? [] :
                    slice.call(
                        isSimple && !maybeID && element.getElementsByClassName ? // DocumentFragment doesn't have getElementsByClassName/TagName
                            maybeClass ? element.getElementsByClassName(nameOnly) : // If it's simple, it could be a class
                                element.getElementsByTagName(selector) : // Or a tag
                            element.querySelectorAll(selector) // Or it's not simple, and we need to query all
                    )
        }

        $.contains = document.documentElement.contains ?
            function (parent, node) {
                return parent !== node && parent.contains(node)
            } :
            function (parent, node) {
                while (node && (node = node.parentNode))
                    if (node === parent) return true
                return false
            }

        function funcArg(context, arg, idx, payload) {
            return isFunction(arg) ? arg.call(context, idx, payload) : arg
        }

        function setAttribute(node, name, value) {
            value == null ? node.removeAttribute(name) : node.setAttribute(name, value)
        }

        // "true"  => true
        // "false" => false
        // "null"  => null
        // "42"    => 42
        // "42.5"  => 42.5
        // "08"    => "08"
        // JSON    => parse if valid
        // String  => self
        function deserializeValue(value) {
            try {
                return value ?
                    value == "true" ||
                    (value == "false" ? false :
                        value == "null" ? null :
                            +value + "" == value ? +value :
                                /^[\[\{]/.test(value) ? $.parseJSON(value) :
                                    value)
                    : value
            } catch (e) {
                return value
            }
        }

        $.type = type
        $.isFunction = isFunction
        $.isWindow = isWindow
        $.isArray = isArray
        $.isPlainObject = isPlainObject

        $.isEmptyObject = function (obj) {
            var name
            for (name in obj) return false
            return true
        }

        $.inArray = function (elem, array, i) {
            return emptyArray.indexOf.call(array, elem, i)
        }

        $.camelCase = camelize
        $.trim = function (str) {
            return str == null ? "" : String.prototype.trim.call(str)
        }

        // plugin compatibility
        $.uuid = 0
        $.support = {}
        $.expr = {}
        $.noop = function () { }

        $.map = function (elements, callback) {
            var value, values = [], i, key
            if (likeArray(elements))
                for (i = 0; i < elements.length; i++) {
                    value = callback(elements[i], i)
                    if (value != null) values.push(value)
                }
            else
                for (key in elements) {
                    value = callback(elements[key], key)
                    if (value != null) values.push(value)
                }
            return flatten(values)
        }

        $.each = function (elements, callback) {
            var i, key
            if (likeArray(elements)) {
                for (i = 0; i < elements.length; i++)
                    if (callback.call(elements[i], i, elements[i]) === false) return elements
            } else {
                for (key in elements)
                    if (callback.call(elements[key], key, elements[key]) === false) return elements
            }

            return elements
        }

        if (window.JSON) $.parseJSON = JSON.parse

        // Populate the class2type map
        $.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function (i, name) {
            class2type["[object " + name + "]"] = name.toLowerCase()
        })

        // Define methods that will be available on all
        // Zepto collections
        $.fn = {
            constructor: zepto.Z,
            length: 0,

            // Because a collection acts like an array
            // copy over these useful array functions.
            forEach: emptyArray.forEach,
            reduce: emptyArray.reduce,
            push: emptyArray.push,
            sort: emptyArray.sort,
            splice: emptyArray.splice,
            indexOf: emptyArray.indexOf,
            concat: function () {
                var i, value, args = []
                for (i = 0; i < arguments.length; i++) {
                    value = arguments[i]
                    args[i] = zepto.isZ(value) ? value.toArray() : value
                }
                return concat.apply(zepto.isZ(this) ? this.toArray() : this, args)
            },

            // `map` and `slice` in the jQuery API work differently
            // from their array counterparts
            map: function (fn) {
                return $($.map(this, function (el, i) { return fn.call(el, i, el) }))
            },
            slice: function () {
                return $(slice.apply(this, arguments))
            },

            ready: function (callback) {
                // need to check if document.body exists for IE as that browser reports
                // document ready when it hasn't yet created the body element
                if (readyRE.test(document.readyState) && document.body) callback($)
                else document.addEventListener('DOMContentLoaded', function () { callback($) }, false)
                return this
            },
            get: function (idx) {
                return idx === undefined ? slice.call(this) : this[idx >= 0 ? idx : idx + this.length]
            },
            toArray: function () { return this.get() },
            remove: function () {
                return this.each(function () {
                    if (this.parentNode != null)
                        this.parentNode.removeChild(this)
                })
            },
            each: function (callback) {
                emptyArray.every.call(this, function (el, idx) {
                    return callback.call(el, idx, el) !== false
                })
                return this
            },
            filter: function (selector) {
                if (isFunction(selector)) return this.not(this.not(selector))
                return $(filter.call(this, function (element) {
                    return zepto.matches(element, selector)
                }))
            },
            add: function (selector, context) {
                return $(uniq(this.concat($(selector, context))))
            },
            not: function (selector) {
                var nodes = []
                if (isFunction(selector) && selector.call !== undefined)
                    this.each(function (idx) {
                        if (!selector.call(this, idx)) nodes.push(this)
                    })
                else {
                    var excludes = typeof selector == 'string' ? this.filter(selector) :
                        (likeArray(selector) && isFunction(selector.item)) ? slice.call(selector) : $(selector)
                    this.forEach(function (el) {
                        if (excludes.indexOf(el) < 0) nodes.push(el)
                    })
                }
                return $(nodes)
            },
            eq: function (idx) {
                return idx === -1 ? this.slice(idx) : this.slice(idx, + idx + 1)
            },
            find: function (selector) {
                var result, $this = this
                if (!selector) result = $()
                else if (typeof selector == 'object')
                    result = $(selector).filter(function () {
                        var node = this
                        return emptyArray.some.call($this, function (parent) {
                            return $.contains(parent, node)
                        })
                    })
                else if (this.length == 1) result = $(zepto.qsa(this[0], selector))
                else result = this.map(function () { return zepto.qsa(this, selector) })
                return result
            },
            closest: function (selector, context) {
                var nodes = [], collection = typeof selector == 'object' && $(selector)
                this.each(function (_, node) {
                    while (node && !(collection ? collection.indexOf(node) >= 0 : zepto.matches(node, selector)))
                        node = node !== context && !isDocument(node) && node.parentNode
                    if (node && nodes.indexOf(node) < 0) nodes.push(node)
                })
                return $(nodes)
            },
            empty: function () {
                return this.each(function () { this.innerHTML = '' })
            },
            // `pluck` is borrowed from Prototype.js
            pluck: function (property) {
                return $.map(this, function (el) { return el[property] })
            },
            html: function (html) {
                return 0 in arguments ?
                    this.each(function (idx) {
                        var originHtml = this.innerHTML
                        $(this).empty().append(funcArg(this, html, idx, originHtml))
                    }) :
                    (0 in this ? this[0].innerHTML : null)
            },
            attr: function (name, value) {
                var result
                return (typeof name == 'string' && !(1 in arguments)) ?
                    (0 in this && this[0].nodeType == 1 && (result = this[0].getAttribute(name)) != null ? result : undefined) :
                    this.each(function (idx) {
                        if (this.nodeType !== 1) return
                        if (isObject(name)) for (key in name) setAttribute(this, key, name[key])
                        else setAttribute(this, name, funcArg(this, value, idx, this.getAttribute(name)))
                    })
            },
            val: function (value) {
                if (0 in arguments) {
                    if (value == null) value = ""
                    return this.each(function (idx) {
                        this.value = funcArg(this, value, idx, this.value)
                    })
                } else {
                    return this[0] && (this[0].multiple ?
                        $(this[0]).find('option').filter(function () { return this.selected }).pluck('value') :
                        this[0].value)
                }
            },
        }

        // for now
        $.fn.detach = $.fn.remove

        function traverseNode(node, fun) {
            fun(node)
            for (var i = 0, len = node.childNodes.length; i < len; i++)
                traverseNode(node.childNodes[i], fun)
        }

        // Generate the `after`, `prepend`, `before`, `append`,
        // `insertAfter`, `insertBefore`, `appendTo`, and `prependTo` methods.
        adjacencyOperators.forEach(function (operator, operatorIndex) {
            var inside = operatorIndex % 2 //=> prepend, append

            $.fn[operator] = function () {
                // arguments can be nodes, arrays of nodes, Zepto objects and HTML strings
                var argType, nodes = $.map(arguments, function (arg) {
                    var arr = []
                    argType = type(arg)
                    if (argType == "array") {
                        arg.forEach(function (el) {
                            if (el.nodeType !== undefined) return arr.push(el)
                            else if ($.zepto.isZ(el)) return arr = arr.concat(el.get())
                            arr = arr.concat(zepto.fragment(el))
                        })
                        return arr
                    }
                    return argType == "object" || arg == null ?
                        arg : zepto.fragment(arg)
                }),
                    parent, copyByClone = this.length > 1
                if (nodes.length < 1) return this

                return this.each(function (_, target) {
                    parent = inside ? target : target.parentNode

                    // convert all methods to a "before" operation
                    target = operatorIndex == 0 ? target.nextSibling :
                        operatorIndex == 1 ? target.firstChild :
                            operatorIndex == 2 ? target :
                                null

                    var parentInDocument = $.contains(document.documentElement, parent)

                    nodes.forEach(function (node) {
                        if (copyByClone) node = node.cloneNode(true)
                        else if (!parent) return $(node).remove()

                        parent.insertBefore(node, target)
                        if (parentInDocument) traverseNode(node, function (el) {
                            if (el.nodeName != null && el.nodeName.toUpperCase() === 'SCRIPT' &&
                                (!el.type || el.type === 'text/javascript') && !el.src) {
                                var target = el.ownerDocument ? el.ownerDocument.defaultView : window
                                target['eval'].call(target, el.innerHTML)
                            }
                        })
                    })
                })
            }

            // after    => insertAfter
            // prepend  => prependTo
            // before   => insertBefore
            // append   => appendTo
            $.fn[inside ? operator + 'To' : 'insert' + (operatorIndex ? 'Before' : 'After')] = function (html) {
                $(html)[operator](this)
                return this
            }
        })

        zepto.Z.prototype = Z.prototype = $.fn

        // Export internal API functions in the `$.zepto` namespace
        zepto.uniq = uniq
        zepto.deserializeValue = deserializeValue
        $.zepto = zepto

        return $
    })()

    window.Zepto = Zepto
    window.$ === undefined && (window.$ = Zepto)

        ; (function ($) {
            var _zid = 1, undefined,
                slice = Array.prototype.slice,
                isFunction = $.isFunction,
                isString = function (obj) { return typeof obj == 'string' },
                handlers = {},
                specialEvents = {},
                focusinSupported = 'onfocusin' in window,
                focus = { focus: 'focusin', blur: 'focusout' },
                hover = { mouseenter: 'mouseover', mouseleave: 'mouseout' }

            specialEvents.click = specialEvents.mousedown = specialEvents.mouseup = specialEvents.mousemove = 'MouseEvents'

            function zid(element) {
                return element._zid || (element._zid = _zid++)
            }
            function findHandlers(element, event, fn, selector) {
                event = parse(event)
                if (event.ns) var matcher = matcherFor(event.ns)
                return (handlers[zid(element)] || []).filter(function (handler) {
                    return handler
                        && (!event.e || handler.e == event.e)
                        && (!event.ns || matcher.test(handler.ns))
                        && (!fn || zid(handler.fn) === zid(fn))
                        && (!selector || handler.sel == selector)
                })
            }
            function parse(event) {
                var parts = ('' + event).split('.')
                return { e: parts[0], ns: parts.slice(1).sort().join(' ') }
            }
            function matcherFor(ns) {
                return new RegExp('(?:^| )' + ns.replace(' ', ' .* ?') + '(?: |$)')
            }

            function eventCapture(handler, captureSetting) {
                return handler.del &&
                    (!focusinSupported && (handler.e in focus)) ||
                    !!captureSetting
            }

            function realEvent(type) {
                return hover[type] || (focusinSupported && focus[type]) || type
            }

            function add(element, events, fn, data, selector, delegator, capture) {
                var id = zid(element), set = (handlers[id] || (handlers[id] = []))
                events.split(/\s/).forEach(function (event) {
                    if (event == 'ready') return $(document).ready(fn)
                    var handler = parse(event)
                    handler.fn = fn
                    handler.sel = selector
                    // emulate mouseenter, mouseleave
                    if (handler.e in hover) fn = function (e) {
                        var related = e.relatedTarget
                        if (!related || (related !== this && !$.contains(this, related)))
                            return handler.fn.apply(this, arguments)
                    }
                    handler.del = delegator
                    var callback = delegator || fn
                    handler.proxy = function (e) {
                        e = compatible(e)
                        if (e.isImmediatePropagationStopped()) return
                        e.data = data
                        var result = callback.apply(element, e._args == undefined ? [e] : [e].concat(e._args))
                        if (result === false) e.preventDefault(), e.stopPropagation()
                        return result
                    }
                    handler.i = set.length
                    set.push(handler)
                    if ('addEventListener' in element)
                        element.addEventListener(realEvent(handler.e), handler.proxy, eventCapture(handler, capture))
                })
            }
            function remove(element, events, fn, selector, capture) {
                var id = zid(element)
                    ; (events || '').split(/\s/).forEach(function (event) {
                        findHandlers(element, event, fn, selector).forEach(function (handler) {
                            delete handlers[id][handler.i]
                            if ('removeEventListener' in element)
                                element.removeEventListener(realEvent(handler.e), handler.proxy, eventCapture(handler, capture))
                        })
                    })
            }

            $.event = { add: add, remove: remove }

            $.proxy = function (fn, context) {
                var args = (2 in arguments) && slice.call(arguments, 2)
                if (isFunction(fn)) {
                    var proxyFn = function () { return fn.apply(context, args ? args.concat(slice.call(arguments)) : arguments) }
                    proxyFn._zid = zid(fn)
                    return proxyFn
                } else if (isString(context)) {
                    if (args) {
                        args.unshift(fn[context], fn)
                        return $.proxy.apply(null, args)
                    } else {
                        return $.proxy(fn[context], fn)
                    }
                } else {
                    throw new TypeError("expected function")
                }
            }

            $.fn.bind = function (event, data, callback) {
                return this.on(event, data, callback)
            }
            $.fn.unbind = function (event, callback) {
                return this.off(event, callback)
            }
            $.fn.one = function (event, selector, data, callback) {
                return this.on(event, selector, data, callback, 1)
            }

            var returnTrue = function () { return true },
                returnFalse = function () { return false },
                ignoreProperties = /^([A-Z]|returnValue$|layer[XY]$|webkitMovement[XY]$)/,
                eventMethods = {
                    preventDefault: 'isDefaultPrevented',
                    stopImmediatePropagation: 'isImmediatePropagationStopped',
                    stopPropagation: 'isPropagationStopped'
                }

            function compatible(event, source) {
                if (source || !event.isDefaultPrevented) {
                    source || (source = event)

                    $.each(eventMethods, function (name, predicate) {
                        var sourceMethod = source[name]
                        event[name] = function () {
                            this[predicate] = returnTrue
                            return sourceMethod && sourceMethod.apply(source, arguments)
                        }
                        event[predicate] = returnFalse
                    })

                    event.timeStamp || (event.timeStamp = Date.now())

                    if (source.defaultPrevented !== undefined ? source.defaultPrevented :
                        'returnValue' in source ? source.returnValue === false :
                            source.getPreventDefault && source.getPreventDefault())
                        event.isDefaultPrevented = returnTrue
                }
                return event
            }

            function createProxy(event) {
                var key, proxy = { originalEvent: event }
                for (key in event)
                    if (!ignoreProperties.test(key) && event[key] !== undefined) proxy[key] = event[key]

                return compatible(proxy, event)
            }

            $.fn.delegate = function (selector, event, callback) {
                return this.on(event, selector, callback)
            }
            $.fn.undelegate = function (selector, event, callback) {
                return this.off(event, selector, callback)
            }

            $.fn.live = function (event, callback) {
                $(document.body).delegate(this.selector, event, callback)
                return this
            }
            $.fn.die = function (event, callback) {
                $(document.body).undelegate(this.selector, event, callback)
                return this
            }

            $.fn.on = function (event, selector, data, callback, one) {
                var autoRemove, delegator, $this = this
                if (event && !isString(event)) {
                    $.each(event, function (type, fn) {
                        $this.on(type, selector, data, fn, one)
                    })
                    return $this
                }

                if (!isString(selector) && !isFunction(callback) && callback !== false)
                    callback = data, data = selector, selector = undefined
                if (callback === undefined || data === false)
                    callback = data, data = undefined

                if (callback === false) callback = returnFalse

                return $this.each(function (_, element) {
                    if (one) autoRemove = function (e) {
                        remove(element, e.type, callback)
                        return callback.apply(this, arguments)
                    }

                    if (selector) delegator = function (e) {
                        var evt, match = $(e.target).closest(selector, element).get(0)
                        if (match && match !== element) {
                            evt = $.extend(createProxy(e), { currentTarget: match, liveFired: element })
                            return (autoRemove || callback).apply(match, [evt].concat(slice.call(arguments, 1)))
                        }
                    }

                    add(element, event, callback, data, selector, delegator || autoRemove)
                })
            }
            $.fn.off = function (event, selector, callback) {
                var $this = this
                if (event && !isString(event)) {
                    $.each(event, function (type, fn) {
                        $this.off(type, selector, fn)
                    })
                    return $this
                }

                if (!isString(selector) && !isFunction(callback) && callback !== false)
                    callback = selector, selector = undefined

                if (callback === false) callback = returnFalse

                return $this.each(function () {
                    remove(this, event, callback, selector)
                })
            }

            $.fn.trigger = function (event, args) {
                event = (isString(event) || $.isPlainObject(event)) ? $.Event(event) : compatible(event)
                event._args = args
                return this.each(function () {
                    // handle focus(), blur() by calling them directly
                    if (event.type in focus && typeof this[event.type] == "function") this[event.type]()
                    // items in the collection might not be DOM elements
                    else if ('dispatchEvent' in this) this.dispatchEvent(event)
                    else $(this).triggerHandler(event, args)
                })
            }

            // triggers event handlers on current element just as if an event occurred,
            // doesn't trigger an actual event, doesn't bubble
            $.fn.triggerHandler = function (event, args) {
                var e, result
                this.each(function (i, element) {
                    e = createProxy(isString(event) ? $.Event(event) : event)
                    e._args = args
                    e.target = element
                    $.each(findHandlers(element, event.type || event), function (i, handler) {
                        result = handler.proxy(e)
                        if (e.isImmediatePropagationStopped()) return false
                    })
                })
                return result
            }

                // shortcut methods for `.bind(event, fn)` for each event type
                ; ('focusin focusout focus blur load resize scroll unload click dblclick ' +
                    'mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave ' +
                    'change select keydown keypress keyup error').split(' ').forEach(function (event) {
                        $.fn[event] = function (callback) {
                            return (0 in arguments) ?
                                this.bind(event, callback) :
                                this.trigger(event)
                        }
                    })

            $.Event = function (type, props) {
                if (!isString(type)) props = type, type = props.type
                var event = document.createEvent(specialEvents[type] || 'Events'), bubbles = true
                if (props) for (var name in props) (name == 'bubbles') ? (bubbles = !!props[name]) : (event[name] = props[name])
                event.initEvent(type, bubbles, true)
                return compatible(event)
            }

        })(Zepto)

        ; (function ($) {
            var jsonpID = +new Date(),
                document = window.document,
                key,
                name,
                rscript = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,
                scriptTypeRE = /^(?:text|application)\/javascript/i,
                xmlTypeRE = /^(?:text|application)\/xml/i,
                jsonType = 'application/json',
                htmlType = 'text/html',
                blankRE = /^\s*$/,
                originAnchor = document.createElement('a')

            originAnchor.href = window.location.href

            // trigger a custom event and return false if it was cancelled
            function triggerAndReturn(context, eventName, data) {
                var event = $.Event(eventName)
                $(context).trigger(event, data)
                return !event.isDefaultPrevented()
            }

            // trigger an Ajax "global" event
            function triggerGlobal(settings, context, eventName, data) {
                if (settings.global) return triggerAndReturn(context || document, eventName, data)
            }

            // Number of active Ajax requests
            $.active = 0

            function ajaxStart(settings) {
                if (settings.global && $.active++ === 0) triggerGlobal(settings, null, 'ajaxStart')
            }
            function ajaxStop(settings) {
                if (settings.global && !(--$.active)) triggerGlobal(settings, null, 'ajaxStop')
            }

            // triggers an extra global event "ajaxBeforeSend" that's like "ajaxSend" but cancelable
            function ajaxBeforeSend(xhr, settings) {
                var context = settings.context
                if (settings.beforeSend.call(context, xhr, settings) === false ||
                    triggerGlobal(settings, context, 'ajaxBeforeSend', [xhr, settings]) === false)
                    return false

                triggerGlobal(settings, context, 'ajaxSend', [xhr, settings])
            }
            function ajaxSuccess(data, xhr, settings, deferred) {
                var context = settings.context, status = 'success'
                settings.success.call(context, data, status, xhr)
                if (deferred) deferred.resolveWith(context, [data, status, xhr])
                triggerGlobal(settings, context, 'ajaxSuccess', [xhr, settings, data])
                ajaxComplete(status, xhr, settings)
            }
            // type: "timeout", "error", "abort", "parsererror"
            function ajaxError(error, type, xhr, settings, deferred) {
                var context = settings.context
                settings.error.call(context, xhr, type, error)
                if (deferred) deferred.rejectWith(context, [xhr, type, error])
                triggerGlobal(settings, context, 'ajaxError', [xhr, settings, error || type])
                ajaxComplete(type, xhr, settings)
            }
            // status: "success", "notmodified", "error", "timeout", "abort", "parsererror"
            function ajaxComplete(status, xhr, settings) {
                var context = settings.context
                settings.complete.call(context, xhr, status)
                triggerGlobal(settings, context, 'ajaxComplete', [xhr, settings])
                ajaxStop(settings)
            }

            function ajaxDataFilter(data, type, settings) {
                if (settings.dataFilter == empty) return data
                var context = settings.context
                return settings.dataFilter.call(context, data, type)
            }

            // Empty function, used as default callback
            function empty() { }

            $.ajaxJSONP = function (options, deferred) {
                if (!('type' in options)) return $.ajax(options)

                var _callbackName = options.jsonpCallback,
                    callbackName = ($.isFunction(_callbackName) ?
                        _callbackName() : _callbackName) || ('Zepto' + (jsonpID++)),
                    script = document.createElement('script'),
                    originalCallback = window[callbackName],
                    responseData,
                    abort = function (errorType) {
                        $(script).triggerHandler('error', errorType || 'abort')
                    },
                    xhr = { abort: abort }, abortTimeout

                if (deferred) deferred.promise(xhr)

                $(script).on('load error', function (e, errorType) {
                    clearTimeout(abortTimeout)
                    $(script).off().remove()

                    if (e.type == 'error' || !responseData) {
                        ajaxError(null, errorType || 'error', xhr, options, deferred)
                    } else {
                        ajaxSuccess(responseData[0], xhr, options, deferred)
                    }

                    window[callbackName] = originalCallback
                    if (responseData && $.isFunction(originalCallback))
                        originalCallback(responseData[0])

                    originalCallback = responseData = undefined
                })

                if (ajaxBeforeSend(xhr, options) === false) {
                    abort('abort')
                    return xhr
                }

                window[callbackName] = function () {
                    responseData = arguments
                }

                script.src = options.url.replace(/\?(.+)=\?/, '?$1=' + callbackName)
                document.head.appendChild(script)

                if (options.timeout > 0) abortTimeout = setTimeout(function () {
                    abort('timeout')
                }, options.timeout)

                return xhr
            }

            $.ajaxSettings = {
                // Default type of request
                type: 'GET',
                // Callback that is executed before request
                beforeSend: empty,
                // Callback that is executed if the request succeeds
                success: empty,
                // Callback that is executed the the server drops error
                error: empty,
                // Callback that is executed on request complete (both: error and success)
                complete: empty,
                // The context for the callbacks
                context: null,
                // Whether to trigger "global" Ajax events
                global: true,
                // Transport
                xhr: function () {
                    return new window.XMLHttpRequest()
                },
                // MIME types mapping
                // IIS returns Javascript as "application/x-javascript"
                accepts: {
                    script: 'text/javascript, application/javascript, application/x-javascript',
                    json: jsonType,
                    xml: 'application/xml, text/xml',
                    html: htmlType,
                    text: 'text/plain'
                },
                // Whether the request is to another domain
                crossDomain: false,
                // Default timeout
                timeout: 0,
                // Whether data should be serialized to string
                processData: true,
                // Whether the browser should be allowed to cache GET responses
                cache: true,
                //Used to handle the raw response data of XMLHttpRequest.
                //This is a pre-filtering function to sanitize the response.
                //The sanitized response should be returned
                dataFilter: empty
            }

            function mimeToDataType(mime) {
                if (mime) mime = mime.split(';', 2)[0]
                return mime && (mime == htmlType ? 'html' :
                    mime == jsonType ? 'json' :
                        scriptTypeRE.test(mime) ? 'script' :
                            xmlTypeRE.test(mime) && 'xml') || 'text'
            }

            function appendQuery(url, query) {
                if (query == '') return url
                return (url + '&' + query).replace(/[&?]{1,2}/, '?')
            }

            // serialize payload and append it to the URL for GET requests
            function serializeData(options) {
                if (options.processData && options.data && $.type(options.data) != "string")
                    options.data = $.param(options.data, options.traditional)
                if (options.data && (!options.type || options.type.toUpperCase() == 'GET' || 'jsonp' == options.dataType))
                    options.url = appendQuery(options.url, options.data), options.data = undefined
            }

            $.ajax = function (options) {
                var settings = $.extend({}, options || {}),
                    deferred = $.Deferred && $.Deferred(),
                    urlAnchor, hashIndex
                for (key in $.ajaxSettings) if (settings[key] === undefined) settings[key] = $.ajaxSettings[key]

                ajaxStart(settings)

                if (!settings.crossDomain) {
                    urlAnchor = document.createElement('a')
                    urlAnchor.href = settings.url
                    // cleans up URL for .href (IE only), see https://github.com/madrobby/zepto/pull/1049
                    urlAnchor.href = urlAnchor.href
                    settings.crossDomain = (originAnchor.protocol + '//' + originAnchor.host) !== (urlAnchor.protocol + '//' + urlAnchor.host)
                }

                if (!settings.url) settings.url = window.location.toString()
                if ((hashIndex = settings.url.indexOf('#')) > -1) settings.url = settings.url.slice(0, hashIndex)
                serializeData(settings)

                var dataType = settings.dataType, hasPlaceholder = /\?.+=\?/.test(settings.url)
                if (hasPlaceholder) dataType = 'jsonp'

                if (settings.cache === false || (
                    (!options || options.cache !== true) &&
                    ('script' == dataType || 'jsonp' == dataType)
                ))
                    settings.url = appendQuery(settings.url, '_=' + Date.now())

                if ('jsonp' == dataType) {
                    if (!hasPlaceholder)
                        settings.url = appendQuery(settings.url,
                            settings.jsonp ? (settings.jsonp + '=?') : settings.jsonp === false ? '' : 'callback=?')
                    return $.ajaxJSONP(settings, deferred)
                }

                var mime = settings.accepts[dataType],
                    headers = {},
                    setHeader = function (name, value) { headers[name.toLowerCase()] = [name, value] },
                    protocol = /^([\w-]+:)\/\//.test(settings.url) ? RegExp.$1 : window.location.protocol,
                    xhr = settings.xhr(),
                    nativeSetHeader = xhr.setRequestHeader,
                    abortTimeout

                if (deferred) deferred.promise(xhr)

                if (!settings.crossDomain) setHeader('X-Requested-With', 'XMLHttpRequest')
                setHeader('Accept', mime || '*/*')
                if (mime = settings.mimeType || mime) {
                    if (mime.indexOf(',') > -1) mime = mime.split(',', 2)[0]
                    xhr.overrideMimeType && xhr.overrideMimeType(mime)
                }
                if (settings.contentType || (settings.contentType !== false && settings.data && settings.type.toUpperCase() != 'GET'))
                    setHeader('Content-Type', settings.contentType || 'application/x-www-form-urlencoded')

                if (settings.headers) for (name in settings.headers) setHeader(name, settings.headers[name])
                xhr.setRequestHeader = setHeader

                xhr.onreadystatechange = function () {
                    if (xhr.readyState == 4) {
                        xhr.onreadystatechange = empty
                        clearTimeout(abortTimeout)
                        var result, error = false
                        if ((xhr.status >= 200 && xhr.status < 300) || xhr.status == 304 || (xhr.status == 0 && protocol == 'file:')) {
                            dataType = dataType || mimeToDataType(settings.mimeType || xhr.getResponseHeader('content-type'))

                            if (xhr.responseType == 'arraybuffer' || xhr.responseType == 'blob')
                                result = xhr.response
                            else {
                                result = xhr.responseText

                                try {
                                    // http://perfectionkills.com/global-eval-what-are-the-options/
                                    // sanitize response accordingly if data filter callback provided
                                    result = ajaxDataFilter(result, dataType, settings)
                                    if (dataType == 'script') (1, eval)(result)
                                    else if (dataType == 'xml') result = xhr.responseXML
                                    else if (dataType == 'json') result = blankRE.test(result) ? null : $.parseJSON(result)
                                } catch (e) { error = e }

                                if (error) return ajaxError(error, 'parsererror', xhr, settings, deferred)
                            }

                            ajaxSuccess(result, xhr, settings, deferred)
                        } else {
                            ajaxError(xhr.statusText || null, xhr.status ? 'error' : 'abort', xhr, settings, deferred)
                        }
                    }
                }

                if (ajaxBeforeSend(xhr, settings) === false) {
                    xhr.abort()
                    ajaxError(null, 'abort', xhr, settings, deferred)
                    return xhr
                }

                var async = 'async' in settings ? settings.async : true
                xhr.open(settings.type, settings.url, async, settings.username, settings.password)

                if (settings.xhrFields) for (name in settings.xhrFields) xhr[name] = settings.xhrFields[name]

                for (name in headers) nativeSetHeader.apply(xhr, headers[name])

                if (settings.timeout > 0) abortTimeout = setTimeout(function () {
                    xhr.onreadystatechange = empty
                    xhr.abort()
                    ajaxError(null, 'timeout', xhr, settings, deferred)
                }, settings.timeout)

                // avoid sending empty string (#319)
                xhr.send(settings.data ? settings.data : null)
                return xhr
            }

            // handle optional data/success arguments
            function parseArguments(url, data, success, dataType) {
                if ($.isFunction(data)) dataType = success, success = data, data = undefined
                if (!$.isFunction(success)) dataType = success, success = undefined
                return {
                    url: url
                    , data: data
                    , success: success
                    , dataType: dataType
                }
            }

            $.get = function (/* url, data, success, dataType */) {
                return $.ajax(parseArguments.apply(null, arguments))
            }

            $.post = function (/* url, data, success, dataType */) {
                var options = parseArguments.apply(null, arguments)
                options.type = 'POST'
                return $.ajax(options)
            }

            $.getJSON = function (/* url, data, success */) {
                var options = parseArguments.apply(null, arguments)
                options.dataType = 'json'
                return $.ajax(options)
            }

            $.fn.load = function (url, data, success) {
                if (!this.length) return this
                var self = this, parts = url.split(/\s/), selector,
                    options = parseArguments(url, data, success),
                    callback = options.success
                if (parts.length > 1) options.url = parts[0], selector = parts[1]
                options.success = function (response) {
                    self.html(selector ?
                        $('<div>').html(response.replace(rscript, "")).find(selector)
                        : response)
                    callback && callback.apply(self, arguments)
                }
                $.ajax(options)
                return this
            }

            var escape = encodeURIComponent

            function serialize(params, obj, traditional, scope) {
                var type, array = $.isArray(obj), hash = $.isPlainObject(obj)
                $.each(obj, function (key, value) {
                    type = $.type(value)
                    if (scope) key = traditional ? scope :
                        scope + '[' + (hash || type == 'object' || type == 'array' ? key : '') + ']'
                    // handle data in serializeArray() format
                    if (!scope && array) params.add(value.name, value.value)
                    // recurse into nested objects
                    else if (type == "array" || (!traditional && type == "object"))
                        serialize(params, value, traditional, key)
                    else params.add(key, value)
                })
            }

            $.param = function (obj, traditional) {
                var params = []
                params.add = function (key, value) {
                    if ($.isFunction(value)) value = value()
                    if (value == null) value = ""
                    this.push(escape(key) + '=' + escape(value))
                }
                serialize(params, obj, traditional)
                return params.join('&').replace(/%20/g, '+')
            }
        })(Zepto)

        ; (function ($) {
            $.fn.serializeArray = function () {
                var name, type, result = [],
                    add = function (value) {
                        if (value.forEach) return value.forEach(add)
                        result.push({ name: name, value: value })
                    }
                if (this[0]) $.each(this[0].elements, function (_, field) {
                    type = field.type, name = field.name
                    if (name && field.nodeName.toLowerCase() != 'fieldset' &&
                        !field.disabled && type != 'submit' && type != 'reset' && type != 'button' && type != 'file' &&
                        ((type != 'radio' && type != 'checkbox') || field.checked))
                        add($(field).val())
                })
                return result
            }

            $.fn.serialize = function () {
                var result = []
                this.serializeArray().forEach(function (elm) {
                    result.push(encodeURIComponent(elm.name) + '=' + encodeURIComponent(elm.value))
                })
                return result.join('&')
            }

            $.fn.submit = function (callback) {
                if (0 in arguments) this.bind('submit', callback)
                else if (this.length) {
                    var event = $.Event('submit')
                    this.eq(0).trigger(event)
                    if (!event.isDefaultPrevented()) this.get(0).submit()
                }
                return this
            }

        })(Zepto)

    return Zepto
}));
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t((e="undefined"!=typeof globalThis?globalThis:e||self).Maska={})}(this,(function(e){"use strict";function t(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function n(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}function r(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function a(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function o(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?a(Object(n),!0).forEach((function(t){r(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):a(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var s={"#":{pattern:/[0-9]/},X:{pattern:/[0-9a-zA-Z]/},S:{pattern:/[a-zA-Z]/},A:{pattern:/[a-zA-Z]/,uppercase:!0},a:{pattern:/[a-zA-Z]/,lowercase:!0},"!":{escape:!0},"*":{repeat:!0}};function i(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:s,r=!(arguments.length>3&&void 0!==arguments[3])||arguments[3];return u(t).length>1?l(t)(e,t,n,r):p(e,t,n,r)}function u(e){try{return JSON.parse(e)}catch(t){return[e]}}function l(e){var t=u(e).sort((function(e,t){return e.length-t.length}));return function(e,r,a){var o=!(arguments.length>3&&void 0!==arguments[3])||arguments[3],s=t.map((function(t){return p(e,t,a,!1)})),i=s.pop();for(var u in t)if(n(i,t[u],a))return p(e,t[u],a,o);return""};function n(e,t,n){for(var r in n)n[r].escape&&(t=t.replace(new RegExp(r+".{1}","g"),""));return t.split("").filter((function(e){return n[e]&&n[e].pattern})).length>=e.length}}function p(e,t,n){for(var r=!(arguments.length>3&&void 0!==arguments[3])||arguments[3],a=0,o=0,s="",i="";a<t.length&&o<e.length;){var u=t[a],l=e[o],p=n[u];if(p&&p.pattern)p.pattern.test(l)&&(s+=c(l,p),a++,r&&t[a]&&(n[t[a]]?n[t[a]]&&n[t[a]].escape&&(s+=t[a+1],a+=2):(s+=t[a],a++))),o++;else if(p&&p.repeat){var f=n[t[a-1]];f&&!f.pattern.test(l)?a++:a--}else p&&p.escape&&(u=t[++a]),r&&(s+=u),l===u&&o++,a++}for(;r&&a<t.length;){var v=t[a];if(n[v]){i="";break}i+=v,a++}return s+i}function c(e,t){return t.transform&&(e=t.transform(e)),t.uppercase?e.toLocaleUpperCase():t.lowercase?e.toLocaleLowerCase():e}function f(e){return e instanceof HTMLInputElement?e:e.querySelector("input")||e}function v(e){return"[object String]"===Object.prototype.toString.call(e)}var d=function(){function e(n){var r=this,a=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};if(t(this,e),!n)throw new Error("Maska: no element for mask");if(null!=a.preprocessor&&"function"!=typeof a.preprocessor)throw new Error("Maska: preprocessor must be a function");if(a.tokens)for(var i in a.tokens)a.tokens[i]=o({},a.tokens[i]),a.tokens[i].pattern&&v(a.tokens[i].pattern)&&(a.tokens[i].pattern=new RegExp(a.tokens[i].pattern));this._opts={mask:a.mask,tokens:o(o({},s),a.tokens),preprocessor:a.preprocessor},this._el=v(n)?document.querySelectorAll(n):n.length?n:[n],this.inputEvent=function(e){return r.updateValue(e.target,e)},this.init()}var r,a,u;return r=e,(a=[{key:"init",value:function(){for(var e=this,t=function(t){var n=f(e._el[t]);!e._opts.mask||n.dataset.mask&&n.dataset.mask===e._opts.mask||(n.dataset.mask=e._opts.mask),setTimeout((function(){return e.updateValue(n)}),0),n.dataset.maskInited||(n.dataset.maskInited=!0,n.addEventListener("input",e.inputEvent),n.addEventListener("beforeinput",e.beforeInput))},n=0;n<this._el.length;n++)t(n)}},{key:"destroy",value:function(){for(var e=0;e<this._el.length;e++){var t=f(this._el[e]);t.removeEventListener("input",this.inputEvent),t.removeEventListener("beforeinput",this.beforeInput),delete t.dataset.mask,delete t.dataset.maskInited}}},{key:"updateValue",value:function(e,t){if(e&&e.type){var n=e.type.match(/^number$/i)&&e.validity.badInput;if(!e.value&&!n||!e.dataset.mask)return e.dataset.maskRawValue="",void this.dispatch("maska",e,t);var r=e.selectionEnd,a=e.value,o=a[r-1];e.dataset.maskRawValue=i(e.value,e.dataset.mask,this._opts.tokens,!1);var s=e.value;this._opts.preprocessor&&(s=this._opts.preprocessor(s)),e.value=i(s,e.dataset.mask,this._opts.tokens),t&&"insertText"===t.inputType&&r===a.length&&(r=e.value.length),function(e,t,n){for(;t&&t<e.value.length&&e.value.charAt(t-1)!==n;)t++;(e.type?e.type.match(/^(text|search|password|tel|url)$/i):!e.type)&&e===document.activeElement&&(e.setSelectionRange(t,t),setTimeout((function(){e.setSelectionRange(t,t)}),0))}(e,r,o),this.dispatch("maska",e,t),e.value!==a&&this.dispatch("input",e,t)}}},{key:"beforeInput",value:function(e){e&&e.target&&e.target.type&&e.target.type.match(/^number$/i)&&e.data&&isNaN(e.target.value+e.data)&&e.preventDefault()}},{key:"dispatch",value:function(e,t,n){t.dispatchEvent(function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null,n=document.createEvent("Event");return n.initEvent(e,!0,!0),t&&(n.inputType=t),n}(e,n&&n.inputType||null))}}])&&n(r.prototype,a),u&&n(r,u),e}();var h,k=(h=new WeakMap,function(e,t){t.value&&(h.has(e)&&!function(e){return!(v(e.value)&&e.value===e.oldValue||Array.isArray(e.value)&&JSON.stringify(e.value)===JSON.stringify(e.oldValue)||e.value&&e.value.mask&&e.oldValue&&e.oldValue.mask&&e.value.mask===e.oldValue.mask)}(t)||h.set(e,new d(e,function(e){var t={};return e.mask?(t.mask=Array.isArray(e.mask)?JSON.stringify(e.mask):e.mask,t.tokens=e.tokens?o({},e.tokens):{},t.preprocessor=e.preprocessor):t.mask=Array.isArray(e)?JSON.stringify(e):e,t}(t.value))))});function m(e){e.directive("maska",k)}"undefined"!=typeof window&&window.Vue&&window.Vue.use&&window.Vue.use(m),e.create=function(e,t){return new d(e,t)},e.default=m,e.install=m,e.mask=i,e.maska=k,e.tokens=s,Object.defineProperty(e,"__esModule",{value:!0})}));
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define([], (function () {
      return factory(root, root.document);
    }));
  } else if (typeof exports === 'object') {
    module.exports = factory(root, root.document);
  } else {
    root.skrollTop = factory(root, root.document);
  }
})(typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : this, (function (window, document) {
  'use strict';

  var g_activeAnimation;
  var self = {};

  Math.easeInOutCubic = function (t, b, c, d) {
    if ((t /= d / 2) < 1) return c / 2 * t * t * t + b; return c / 2 * ((t -= 2) * t * t + 2) + b;
  };

  self.stop = function () {
    g_activeAnimation = false;
  };

  self.scrollTo = function (params) {
    console.log(params);
    var element = typeof params.element !== 'undefined' ? params.element : window;
    var to = params.to;
    var duration = typeof params.duration !== 'undefined' ? params.duration : 700;
    var callback = typeof params.callback !== 'undefined' ? params.callback : null;
    var easing = typeof params.easing !== 'undefined' ? params.easing : Math.easeInOutCubic;
    console.log(typeof params.easing !== 'undefined');
    var start = (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);
    var change = to - start;
    var currentTime = 0;
    var increment = 16;
    g_activeAnimation = true;

    var animateScroll = function () {
      if (g_activeAnimation) {
        currentTime += increment;
        element.scrollTo(0, easing(currentTime, start, change, duration));

        if (currentTime < duration) {
          setTimeout(animateScroll, increment);
        } else if (callback) {
          callback();
        }
      } else if (currentTime < duration && callback) {
        callback();
      }
    };

    animateScroll();
  };

  return self;
}));

  // document.querySelector('.aa').addEventListener('click', function () {
  //  var el = document.getElementById('d').getBoundingClientRect();
  //  offset = el.top + document.body.scrollTop
  //  skrollTop.scrollTo({
  //   to: offset,
  //   duration: 800,
  //   callback: function () {
  //    console.log("finished!");
  //   }
  //  });
  // });
const isiOS =
    (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

class BeerSlider {
    constructor(element, isiOS, { start = "50", prefix = "beer" } = {}) {
        this.start = parseInt(start) ? Math.min(100, Math.max(0, parseInt(start))) : 50;
        this.prefix = prefix;
        // swal ios fix
        this.isiOS = isiOS;
        // added
        this.clicked = 0;
        this.imgBoundingClientRect = null;

        if (!element || element.children.length !== 2) {
            return;
        }
        this.element = element;
        this.revealContainer = this.element.children[1];
        if (this.revealContainer.children.length < 1) {
            return;
        }
        this.revealElement = this.revealContainer.children[0];
        this.range = this.addElement("input", {
            type: "range",
            class: `${this.prefix}-range`,
            "aria-label": "Percent of revealed content",
            "aria-valuemin": "0",
            "aria-valuemax": "100",
            "aria-valuenow": this.start,
            value: this.start,
            min: "0",
            max: "100",
        });
        this.handle = this.addElement("span", {
            class: `${this.prefix}-handle`,
        });
        this.onImagesLoad();
    }

    init() {
        this.element.classList.add(`${this.prefix}-ready`);
        this.setImgWidth();
        this.move();
        this.addListeners();
    }
    loadingImg(src) {
        return new Promise((resolve, reject) => {
            if (!src) {
                resolve();
            }
            const img = new Image();
            img.onload = () => resolve();
            img.onerror = () => reject();
            img.src = src;
        });
    }
    loadedBoth() {
        const mainImageSrc = this.element.children[0].src || this.element.children[0].getAttribute(`data-${this.prefix}-src`);
        const revealImageSrc = this.revealElement.src || this.revealElement.getAttribute(`data-${this.prefix}-src`);
        return Promise.all([this.loadingImg(mainImageSrc), this.loadingImg(revealImageSrc)]);
    }
    onImagesLoad() {
        if (!this.revealElement) {
            return;
        }
        this.loadedBoth().then(
            () => {
                this.init();
            },
            () => {
                console.error("Some errors occurred and images are not loaded.");
            }
        );
    }
    addElement(tag, attributes) {
        const el = document.createElement(tag);
        Object.keys(attributes).forEach((key) => {
            el.setAttribute(key, attributes[key]);
        });
        this.element.appendChild(el);
        return el;
    }
    setImgWidth() {
        this.revealElement.style.width = getComputedStyle(this.element)["width"];
        this.imgBoundingClientRect = this.element.getBoundingClientRect();
    }
    addListeners() {
        const eventTypes = ["input", "change"];
        eventTypes.forEach((i) => {
            this.range.addEventListener(i, () => {
                this.move();
            });
        });
        window.addEventListener("resize", () => {
            this.setImgWidth();
        });

        // iOS fix - https://www.w3schools.com/howto/howto_js_image_comparison.asp
        if (isiOS) {
            this.range.addEventListener("mousedown", () => {
                this.slideReady.bind(this);
            });
            window.addEventListener(
                "mouseup",
                () => {
                    this.slideFinish.bind(this);
                },
                Modernizr.passiveeventlisteners ? { passive: true } : false
            );
            this.range.addEventListener("touchstart", () => {
                this.slideReady(event, this);
            });
            window.addEventListener(
                "touchend",
                () => {
                    this.slideFinish(event, this);
                },
                Modernizr.passiveeventlisteners ? { passive: true } : false
            );
        }
    }
    slideReady(e, element) {
        e.preventDefault();
        this.clicked = 1;
        this.lockBodyScroll(e);
        window.addEventListener("mousemove", this.slideMove.bind(this));
        window.addEventListener("touchmove", this.slideMove.bind(this));
    }
    slideFinish(e, element) {
        element.clicked = 0;
    }
    slideMove(e) {
        var pos;
        if (this.clicked == 0) return false;
        pos = this.getCursorPos(e, this);
        if (pos < 0) pos = 0;
        if (pos > 100) pos = 100;
        this.range.value = pos;
        this.move();
    }
    getCursorPos(e, element) {
        var a,
            x = 0;
        if (element.imgBoundingClientRect.left === 0) {
            element.imgBoundingClientRect = this.element.getBoundingClientRect();
        }
        e = e.changedTouches ? e.changedTouches[0] : e;
        x = e.pageX - element.imgBoundingClientRect.left;
        x = x - window.pageXOffset;
        x = Math.round((x / element.imgBoundingClientRect.width) * 100);
        return x;
    }
    // https://github.com/sweetalert2/sweetalert2/blob/ac79cfc4b4a1f3a1e564f1fd353c520ba7a1ca3d/src/utils/iosFix.js
    lockBodyScroll(event) {
        if ((event.touches && event.touches.length && event.touches[0].touchType === "stylus") || (event.touches && event.touches.length > 1)) {
            return;
        }
        event.stopPropagation();
    }

    move() {
        this.revealContainer.style.width = `${this.range.value}%`;
        this.handle.style.left = `${this.range.value}%`;
        this.range.setAttribute("aria-valuenow", this.range.value);
    }
}

document.addEventListener(
    "DOMContentLoaded",
    () => {
        new BeerSlider(document.getElementById("beer-slider01"));
        new BeerSlider(document.getElementById("XY"));
    },
    { passive: true }
);
!function(t,e){"object"==typeof exports&&"object"==typeof module?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.Scrollbar=e():t.Scrollbar=e()}(this,(function(){return function(t){var e={};function n(r){if(e[r])return e[r].exports;var o=e[r]={i:r,l:!1,exports:{}};return t[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=t,n.c=e,n.d=function(t,e,r){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:r})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var o in t)n.d(r,o,function(e){return t[e]}.bind(null,o));return r},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="",n(n.s=65)}([function(t,e,n){(function(e){var n=function(t){return t&&t.Math==Math&&t};t.exports=n("object"==typeof globalThis&&globalThis)||n("object"==typeof window&&window)||n("object"==typeof self&&self)||n("object"==typeof e&&e)||Function("return this")()}).call(this,n(68))},function(t,e,n){var r=n(0),o=n(50),i=n(3),u=n(29),c=n(55),a=n(75),s=o("wks"),f=r.Symbol,l=a?f:f&&f.withoutSetter||u;t.exports=function(t){return i(s,t)||(c&&i(f,t)?s[t]=f[t]:s[t]=l("Symbol."+t)),s[t]}},function(t,e){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,e){var n={}.hasOwnProperty;t.exports=function(t,e){return n.call(t,e)}},function(t,e){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,e,n){var r=n(6),o=n(45),i=n(7),u=n(25),c=Object.defineProperty;e.f=r?c:function(t,e,n){if(i(t),e=u(e,!0),i(n),o)try{return c(t,e,n)}catch(t){}if("get"in n||"set"in n)throw TypeError("Accessors not supported");return"value"in n&&(t[e]=n.value),t}},function(t,e,n){var r=n(4);t.exports=!r((function(){return 7!=Object.defineProperty({},1,{get:function(){return 7}})[1]}))},function(t,e,n){var r=n(2);t.exports=function(t){if(!r(t))throw TypeError(String(t)+" is not an object");return t}},function(t,e,n){var r=n(6),o=n(5),i=n(14);t.exports=r?function(t,e,n){return o.f(t,e,i(1,n))}:function(t,e,n){return t[e]=n,t}},function(t,e,n){var r,o,i,u=n(49),c=n(0),a=n(2),s=n(8),f=n(3),l=n(27),p=n(16),h=c.WeakMap;if(u){var d=new h,v=d.get,y=d.has,m=d.set;r=function(t,e){return m.call(d,t,e),e},o=function(t){return v.call(d,t)||{}},i=function(t){return y.call(d,t)}}else{var g=l("state");p[g]=!0,r=function(t,e){return s(t,g,e),e},o=function(t){return f(t,g)?t[g]:{}},i=function(t){return f(t,g)}}t.exports={set:r,get:o,has:i,enforce:function(t){return i(t)?o(t):r(t,{})},getterFor:function(t){return function(e){var n;if(!a(e)||(n=o(e)).type!==t)throw TypeError("Incompatible receiver, "+t+" required");return n}}}},function(t,e,n){var r=n(0);t.exports=r},function(t,e,n){var r=n(0),o=n(8),i=n(3),u=n(26),c=n(47),a=n(9),s=a.get,f=a.enforce,l=String(String).split("String");(t.exports=function(t,e,n,c){var a=!!c&&!!c.unsafe,s=!!c&&!!c.enumerable,p=!!c&&!!c.noTargetGet;"function"==typeof n&&("string"!=typeof e||i(n,"name")||o(n,"name",e),f(n).source=l.join("string"==typeof e?e:"")),t!==r?(a?!p&&t[e]&&(s=!0):delete t[e],s?t[e]=n:o(t,e,n)):s?t[e]=n:u(e,n)})(Function.prototype,"toString",(function(){return"function"==typeof this&&s(this).source||c(this)}))},function(t,e){t.exports={}},function(t,e,n){var r=n(0),o=n(43).f,i=n(8),u=n(11),c=n(26),a=n(69),s=n(53);t.exports=function(t,e){var n,f,l,p,h,d=t.target,v=t.global,y=t.stat;if(n=v?r:y?r[d]||c(d,{}):(r[d]||{}).prototype)for(f in e){if(p=e[f],l=t.noTargetGet?(h=o(n,f))&&h.value:n[f],!s(v?f:d+(y?".":"#")+f,t.forced)&&void 0!==l){if(typeof p==typeof l)continue;a(p,l)}(t.sham||l&&l.sham)&&i(p,"sham",!0),u(n,f,p,t)}}},function(t,e){t.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}},function(t,e,n){var r=n(22),o=n(24);t.exports=function(t){return r(o(t))}},function(t,e){t.exports={}},function(t,e,n){var r=n(31),o=Math.min;t.exports=function(t){return t>0?o(r(t),9007199254740991):0}},function(t,e,n){var r=n(16),o=n(2),i=n(3),u=n(5).f,c=n(29),a=n(74),s=c("meta"),f=0,l=Object.isExtensible||function(){return!0},p=function(t){u(t,s,{value:{objectID:"O"+ ++f,weakData:{}}})},h=t.exports={REQUIRED:!1,fastKey:function(t,e){if(!o(t))return"symbol"==typeof t?t:("string"==typeof t?"S":"P")+t;if(!i(t,s)){if(!l(t))return"F";if(!e)return"E";p(t)}return t[s].objectID},getWeakData:function(t,e){if(!i(t,s)){if(!l(t))return!0;if(!e)return!1;p(t)}return t[s].weakData},onFreeze:function(t){return a&&h.REQUIRED&&l(t)&&!i(t,s)&&p(t),t}};r[s]=!0},function(t,e,n){var r=n(76);t.exports=function(t,e,n){if(r(t),void 0===e)return t;switch(n){case 0:return function(){return t.call(e)};case 1:return function(n){return t.call(e,n)};case 2:return function(n,r){return t.call(e,n,r)};case 3:return function(n,r,o){return t.call(e,n,r,o)}}return function(){return t.apply(e,arguments)}}},function(t,e,n){var r=n(24);t.exports=function(t){return Object(r(t))}},function(t,e,n){"use strict";var r=n(13),o=n(0),i=n(53),u=n(11),c=n(18),a=n(33),s=n(35),f=n(2),l=n(4),p=n(59),h=n(36),d=n(77);t.exports=function(t,e,n){var v=-1!==t.indexOf("Map"),y=-1!==t.indexOf("Weak"),m=v?"set":"add",g=o[t],x=g&&g.prototype,b=g,w={},S=function(t){var e=x[t];u(x,t,"add"==t?function(t){return e.call(this,0===t?0:t),this}:"delete"==t?function(t){return!(y&&!f(t))&&e.call(this,0===t?0:t)}:"get"==t?function(t){return y&&!f(t)?void 0:e.call(this,0===t?0:t)}:"has"==t?function(t){return!(y&&!f(t))&&e.call(this,0===t?0:t)}:function(t,n){return e.call(this,0===t?0:t,n),this})};if(i(t,"function"!=typeof g||!(y||x.forEach&&!l((function(){(new g).entries().next()})))))b=n.getConstructor(e,t,v,m),c.REQUIRED=!0;else if(i(t,!0)){var _=new b,E=_[m](y?{}:-0,1)!=_,O=l((function(){_.has(1)})),T=p((function(t){new g(t)})),A=!y&&l((function(){for(var t=new g,e=5;e--;)t[m](e,e);return!t.has(-0)}));T||((b=e((function(e,n){s(e,b,t);var r=d(new g,e,b);return null!=n&&a(n,r[m],r,v),r}))).prototype=x,x.constructor=b),(O||A)&&(S("delete"),S("has"),v&&S("get")),(A||E)&&S(m),y&&x.clear&&delete x.clear}return w[t]=b,r({global:!0,forced:b!=g},w),h(b,t),y||n.setStrong(b,t,v),b}},function(t,e,n){var r=n(4),o=n(23),i="".split;t.exports=r((function(){return!Object("z").propertyIsEnumerable(0)}))?function(t){return"String"==o(t)?i.call(t,""):Object(t)}:Object},function(t,e){var n={}.toString;t.exports=function(t){return n.call(t).slice(8,-1)}},function(t,e){t.exports=function(t){if(null==t)throw TypeError("Can't call method on "+t);return t}},function(t,e,n){var r=n(2);t.exports=function(t,e){if(!r(t))return t;var n,o;if(e&&"function"==typeof(n=t.toString)&&!r(o=n.call(t)))return o;if("function"==typeof(n=t.valueOf)&&!r(o=n.call(t)))return o;if(!e&&"function"==typeof(n=t.toString)&&!r(o=n.call(t)))return o;throw TypeError("Can't convert object to primitive value")}},function(t,e,n){var r=n(0),o=n(8);t.exports=function(t,e){try{o(r,t,e)}catch(n){r[t]=e}return e}},function(t,e,n){var r=n(50),o=n(29),i=r("keys");t.exports=function(t){return i[t]||(i[t]=o(t))}},function(t,e){t.exports=!1},function(t,e){var n=0,r=Math.random();t.exports=function(t){return"Symbol("+String(void 0===t?"":t)+")_"+(++n+r).toString(36)}},function(t,e,n){var r=n(10),o=n(0),i=function(t){return"function"==typeof t?t:void 0};t.exports=function(t,e){return arguments.length<2?i(r[t])||i(o[t]):r[t]&&r[t][e]||o[t]&&o[t][e]}},function(t,e){var n=Math.ceil,r=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?r:n)(t)}},function(t,e){t.exports=["constructor","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","toLocaleString","toString","valueOf"]},function(t,e,n){var r=n(7),o=n(54),i=n(17),u=n(19),c=n(56),a=n(58),s=function(t,e){this.stopped=t,this.result=e};(t.exports=function(t,e,n,f,l){var p,h,d,v,y,m,g,x=u(e,n,f?2:1);if(l)p=t;else{if("function"!=typeof(h=c(t)))throw TypeError("Target is not iterable");if(o(h)){for(d=0,v=i(t.length);v>d;d++)if((y=f?x(r(g=t[d])[0],g[1]):x(t[d]))&&y instanceof s)return y;return new s(!1)}p=h.call(t)}for(m=p.next;!(g=m.call(p)).done;)if("object"==typeof(y=a(p,x,g.value,f))&&y&&y instanceof s)return y;return new s(!1)}).stop=function(t){return new s(!0,t)}},function(t,e,n){var r={};r[n(1)("toStringTag")]="z",t.exports="[object z]"===String(r)},function(t,e){t.exports=function(t,e,n){if(!(t instanceof e))throw TypeError("Incorrect "+(n?n+" ":"")+"invocation");return t}},function(t,e,n){var r=n(5).f,o=n(3),i=n(1)("toStringTag");t.exports=function(t,e,n){t&&!o(t=n?t:t.prototype,i)&&r(t,i,{configurable:!0,value:e})}},function(t,e,n){var r,o=n(7),i=n(79),u=n(32),c=n(16),a=n(80),s=n(46),f=n(27)("IE_PROTO"),l=function(){},p=function(t){return"<script>"+t+"<\/script>"},h=function(){try{r=document.domain&&new ActiveXObject("htmlfile")}catch(t){}h=r?function(t){t.write(p("")),t.close();var e=t.parentWindow.Object;return t=null,e}(r):function(){var t,e=s("iframe");return e.style.display="none",a.appendChild(e),e.src=String("javascript:"),(t=e.contentWindow.document).open(),t.write(p("document.F=Object")),t.close(),t.F}();for(var t=u.length;t--;)delete h.prototype[u[t]];return h()};c[f]=!0,t.exports=Object.create||function(t,e){var n;return null!==t?(l.prototype=o(t),n=new l,l.prototype=null,n[f]=t):n=h(),void 0===e?n:i(n,e)}},function(t,e,n){var r=n(11);t.exports=function(t,e,n){for(var o in e)r(t,o,e[o],n);return t}},function(t,e,n){"use strict";var r=n(13),o=n(81),i=n(64),u=n(60),c=n(36),a=n(8),s=n(11),f=n(1),l=n(28),p=n(12),h=n(63),d=h.IteratorPrototype,v=h.BUGGY_SAFARI_ITERATORS,y=f("iterator"),m=function(){return this};t.exports=function(t,e,n,f,h,g,x){o(n,e,f);var b,w,S,_=function(t){if(t===h&&P)return P;if(!v&&t in T)return T[t];switch(t){case"keys":case"values":case"entries":return function(){return new n(this,t)}}return function(){return new n(this)}},E=e+" Iterator",O=!1,T=t.prototype,A=T[y]||T["@@iterator"]||h&&T[h],P=!v&&A||_(h),j="Array"==e&&T.entries||A;if(j&&(b=i(j.call(new t)),d!==Object.prototype&&b.next&&(l||i(b)===d||(u?u(b,d):"function"!=typeof b[y]&&a(b,y,m)),c(b,E,!0,!0),l&&(p[E]=m))),"values"==h&&A&&"values"!==A.name&&(O=!0,P=function(){return A.call(this)}),l&&!x||T[y]===P||a(T,y,P),p[e]=P,h)if(w={values:_("values"),keys:g?P:_("keys"),entries:_("entries")},x)for(S in w)!v&&!O&&S in T||s(T,S,w[S]);else r({target:e,proto:!0,forced:v||O},w);return w}},function(t,e,n){var r=n(34),o=n(11),i=n(84);r||o(Object.prototype,"toString",i,{unsafe:!0})},function(t,e,n){"use strict";var r=n(85).charAt,o=n(9),i=n(39),u=o.set,c=o.getterFor("String Iterator");i(String,"String",(function(t){u(this,{type:"String Iterator",string:String(t),index:0})}),(function(){var t,e=c(this),n=e.string,o=e.index;return o>=n.length?{value:void 0,done:!0}:(t=r(n,o),e.index+=t.length,{value:t,done:!1})}))},function(t,e,n){var r=n(0),o=n(86),i=n(87),u=n(8),c=n(1),a=c("iterator"),s=c("toStringTag"),f=i.values;for(var l in o){var p=r[l],h=p&&p.prototype;if(h){if(h[a]!==f)try{u(h,a,f)}catch(t){h[a]=f}if(h[s]||u(h,s,l),o[l])for(var d in i)if(h[d]!==i[d])try{u(h,d,i[d])}catch(t){h[d]=i[d]}}}},function(t,e,n){var r=n(6),o=n(44),i=n(14),u=n(15),c=n(25),a=n(3),s=n(45),f=Object.getOwnPropertyDescriptor;e.f=r?f:function(t,e){if(t=u(t),e=c(e,!0),s)try{return f(t,e)}catch(t){}if(a(t,e))return i(!o.f.call(t,e),t[e])}},function(t,e,n){"use strict";var r={}.propertyIsEnumerable,o=Object.getOwnPropertyDescriptor,i=o&&!r.call({1:2},1);e.f=i?function(t){var e=o(this,t);return!!e&&e.enumerable}:r},function(t,e,n){var r=n(6),o=n(4),i=n(46);t.exports=!r&&!o((function(){return 7!=Object.defineProperty(i("div"),"a",{get:function(){return 7}}).a}))},function(t,e,n){var r=n(0),o=n(2),i=r.document,u=o(i)&&o(i.createElement);t.exports=function(t){return u?i.createElement(t):{}}},function(t,e,n){var r=n(48),o=Function.toString;"function"!=typeof r.inspectSource&&(r.inspectSource=function(t){return o.call(t)}),t.exports=r.inspectSource},function(t,e,n){var r=n(0),o=n(26),i=r["__core-js_shared__"]||o("__core-js_shared__",{});t.exports=i},function(t,e,n){var r=n(0),o=n(47),i=r.WeakMap;t.exports="function"==typeof i&&/native code/.test(o(i))},function(t,e,n){var r=n(28),o=n(48);(t.exports=function(t,e){return o[t]||(o[t]=void 0!==e?e:{})})("versions",[]).push({version:"3.6.4",mode:r?"pure":"global",copyright:"© 2020 Denis Pushkarev (zloirock.ru)"})},function(t,e,n){var r=n(3),o=n(15),i=n(72).indexOf,u=n(16);t.exports=function(t,e){var n,c=o(t),a=0,s=[];for(n in c)!r(u,n)&&r(c,n)&&s.push(n);for(;e.length>a;)r(c,n=e[a++])&&(~i(s,n)||s.push(n));return s}},function(t,e){e.f=Object.getOwnPropertySymbols},function(t,e,n){var r=n(4),o=/#|\.prototype\./,i=function(t,e){var n=c[u(t)];return n==s||n!=a&&("function"==typeof e?r(e):!!e)},u=i.normalize=function(t){return String(t).replace(o,".").toLowerCase()},c=i.data={},a=i.NATIVE="N",s=i.POLYFILL="P";t.exports=i},function(t,e,n){var r=n(1),o=n(12),i=r("iterator"),u=Array.prototype;t.exports=function(t){return void 0!==t&&(o.Array===t||u[i]===t)}},function(t,e,n){var r=n(4);t.exports=!!Object.getOwnPropertySymbols&&!r((function(){return!String(Symbol())}))},function(t,e,n){var r=n(57),o=n(12),i=n(1)("iterator");t.exports=function(t){if(null!=t)return t[i]||t["@@iterator"]||o[r(t)]}},function(t,e,n){var r=n(34),o=n(23),i=n(1)("toStringTag"),u="Arguments"==o(function(){return arguments}());t.exports=r?o:function(t){var e,n,r;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(n=function(t,e){try{return t[e]}catch(t){}}(e=Object(t),i))?n:u?o(e):"Object"==(r=o(e))&&"function"==typeof e.callee?"Arguments":r}},function(t,e,n){var r=n(7);t.exports=function(t,e,n,o){try{return o?e(r(n)[0],n[1]):e(n)}catch(e){var i=t.return;throw void 0!==i&&r(i.call(t)),e}}},function(t,e,n){var r=n(1)("iterator"),o=!1;try{var i=0,u={next:function(){return{done:!!i++}},return:function(){o=!0}};u[r]=function(){return this},Array.from(u,(function(){throw 2}))}catch(t){}t.exports=function(t,e){if(!e&&!o)return!1;var n=!1;try{var i={};i[r]=function(){return{next:function(){return{done:n=!0}}}},t(i)}catch(t){}return n}},function(t,e,n){var r=n(7),o=n(78);t.exports=Object.setPrototypeOf||("__proto__"in{}?function(){var t,e=!1,n={};try{(t=Object.getOwnPropertyDescriptor(Object.prototype,"__proto__").set).call(n,[]),e=n instanceof Array}catch(t){}return function(n,i){return r(n),o(i),e?t.call(n,i):n.__proto__=i,n}}():void 0)},function(t,e,n){"use strict";var r=n(5).f,o=n(37),i=n(38),u=n(19),c=n(35),a=n(33),s=n(39),f=n(83),l=n(6),p=n(18).fastKey,h=n(9),d=h.set,v=h.getterFor;t.exports={getConstructor:function(t,e,n,s){var f=t((function(t,r){c(t,f,e),d(t,{type:e,index:o(null),first:void 0,last:void 0,size:0}),l||(t.size=0),null!=r&&a(r,t[s],t,n)})),h=v(e),y=function(t,e,n){var r,o,i=h(t),u=m(t,e);return u?u.value=n:(i.last=u={index:o=p(e,!0),key:e,value:n,previous:r=i.last,next:void 0,removed:!1},i.first||(i.first=u),r&&(r.next=u),l?i.size++:t.size++,"F"!==o&&(i.index[o]=u)),t},m=function(t,e){var n,r=h(t),o=p(e);if("F"!==o)return r.index[o];for(n=r.first;n;n=n.next)if(n.key==e)return n};return i(f.prototype,{clear:function(){for(var t=h(this),e=t.index,n=t.first;n;)n.removed=!0,n.previous&&(n.previous=n.previous.next=void 0),delete e[n.index],n=n.next;t.first=t.last=void 0,l?t.size=0:this.size=0},delete:function(t){var e=h(this),n=m(this,t);if(n){var r=n.next,o=n.previous;delete e.index[n.index],n.removed=!0,o&&(o.next=r),r&&(r.previous=o),e.first==n&&(e.first=r),e.last==n&&(e.last=o),l?e.size--:this.size--}return!!n},forEach:function(t){for(var e,n=h(this),r=u(t,arguments.length>1?arguments[1]:void 0,3);e=e?e.next:n.first;)for(r(e.value,e.key,this);e&&e.removed;)e=e.previous},has:function(t){return!!m(this,t)}}),i(f.prototype,n?{get:function(t){var e=m(this,t);return e&&e.value},set:function(t,e){return y(this,0===t?0:t,e)}}:{add:function(t){return y(this,t=0===t?0:t,t)}}),l&&r(f.prototype,"size",{get:function(){return h(this).size}}),f},setStrong:function(t,e,n){var r=e+" Iterator",o=v(e),i=v(r);s(t,e,(function(t,e){d(this,{type:r,target:t,state:o(t),kind:e,last:void 0})}),(function(){for(var t=i(this),e=t.kind,n=t.last;n&&n.removed;)n=n.previous;return t.target&&(t.last=n=n?n.next:t.state.first)?"keys"==e?{value:n.key,done:!1}:"values"==e?{value:n.value,done:!1}:{value:[n.key,n.value],done:!1}:(t.target=void 0,{value:void 0,done:!0})}),n?"entries":"values",!n,!0),f(e)}}},function(t,e,n){var r=n(51),o=n(32);t.exports=Object.keys||function(t){return r(t,o)}},function(t,e,n){"use strict";var r,o,i,u=n(64),c=n(8),a=n(3),s=n(1),f=n(28),l=s("iterator"),p=!1;[].keys&&("next"in(i=[].keys())?(o=u(u(i)))!==Object.prototype&&(r=o):p=!0),null==r&&(r={}),f||a(r,l)||c(r,l,(function(){return this})),t.exports={IteratorPrototype:r,BUGGY_SAFARI_ITERATORS:p}},function(t,e,n){var r=n(3),o=n(20),i=n(27),u=n(82),c=i("IE_PROTO"),a=Object.prototype;t.exports=u?Object.getPrototypeOf:function(t){return t=o(t),r(t,c)?t[c]:"function"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?a:null}},function(t,e,n){t.exports=n(104)},function(t,e,n){n(67),n(40),n(41),n(42);var r=n(10);t.exports=r.Map},function(t,e,n){"use strict";var r=n(21),o=n(61);t.exports=r("Map",(function(t){return function(){return t(this,arguments.length?arguments[0]:void 0)}}),o)},function(t,e){var n;n=function(){return this}();try{n=n||new Function("return this")()}catch(t){"object"==typeof window&&(n=window)}t.exports=n},function(t,e,n){var r=n(3),o=n(70),i=n(43),u=n(5);t.exports=function(t,e){for(var n=o(e),c=u.f,a=i.f,s=0;s<n.length;s++){var f=n[s];r(t,f)||c(t,f,a(e,f))}}},function(t,e,n){var r=n(30),o=n(71),i=n(52),u=n(7);t.exports=r("Reflect","ownKeys")||function(t){var e=o.f(u(t)),n=i.f;return n?e.concat(n(t)):e}},function(t,e,n){var r=n(51),o=n(32).concat("length","prototype");e.f=Object.getOwnPropertyNames||function(t){return r(t,o)}},function(t,e,n){var r=n(15),o=n(17),i=n(73),u=function(t){return function(e,n,u){var c,a=r(e),s=o(a.length),f=i(u,s);if(t&&n!=n){for(;s>f;)if((c=a[f++])!=c)return!0}else for(;s>f;f++)if((t||f in a)&&a[f]===n)return t||f||0;return!t&&-1}};t.exports={includes:u(!0),indexOf:u(!1)}},function(t,e,n){var r=n(31),o=Math.max,i=Math.min;t.exports=function(t,e){var n=r(t);return n<0?o(n+e,0):i(n,e)}},function(t,e,n){var r=n(4);t.exports=!r((function(){return Object.isExtensible(Object.preventExtensions({}))}))},function(t,e,n){var r=n(55);t.exports=r&&!Symbol.sham&&"symbol"==typeof Symbol.iterator},function(t,e){t.exports=function(t){if("function"!=typeof t)throw TypeError(String(t)+" is not a function");return t}},function(t,e,n){var r=n(2),o=n(60);t.exports=function(t,e,n){var i,u;return o&&"function"==typeof(i=e.constructor)&&i!==n&&r(u=i.prototype)&&u!==n.prototype&&o(t,u),t}},function(t,e,n){var r=n(2);t.exports=function(t){if(!r(t)&&null!==t)throw TypeError("Can't set "+String(t)+" as a prototype");return t}},function(t,e,n){var r=n(6),o=n(5),i=n(7),u=n(62);t.exports=r?Object.defineProperties:function(t,e){i(t);for(var n,r=u(e),c=r.length,a=0;c>a;)o.f(t,n=r[a++],e[n]);return t}},function(t,e,n){var r=n(30);t.exports=r("document","documentElement")},function(t,e,n){"use strict";var r=n(63).IteratorPrototype,o=n(37),i=n(14),u=n(36),c=n(12),a=function(){return this};t.exports=function(t,e,n){var s=e+" Iterator";return t.prototype=o(r,{next:i(1,n)}),u(t,s,!1,!0),c[s]=a,t}},function(t,e,n){var r=n(4);t.exports=!r((function(){function t(){}return t.prototype.constructor=null,Object.getPrototypeOf(new t)!==t.prototype}))},function(t,e,n){"use strict";var r=n(30),o=n(5),i=n(1),u=n(6),c=i("species");t.exports=function(t){var e=r(t),n=o.f;u&&e&&!e[c]&&n(e,c,{configurable:!0,get:function(){return this}})}},function(t,e,n){"use strict";var r=n(34),o=n(57);t.exports=r?{}.toString:function(){return"[object "+o(this)+"]"}},function(t,e,n){var r=n(31),o=n(24),i=function(t){return function(e,n){var i,u,c=String(o(e)),a=r(n),s=c.length;return a<0||a>=s?t?"":void 0:(i=c.charCodeAt(a))<55296||i>56319||a+1===s||(u=c.charCodeAt(a+1))<56320||u>57343?t?c.charAt(a):i:t?c.slice(a,a+2):u-56320+(i-55296<<10)+65536}};t.exports={codeAt:i(!1),charAt:i(!0)}},function(t,e){t.exports={CSSRuleList:0,CSSStyleDeclaration:0,CSSValueList:0,ClientRectList:0,DOMRectList:0,DOMStringList:0,DOMTokenList:1,DataTransferItemList:0,FileList:0,HTMLAllCollection:0,HTMLCollection:0,HTMLFormElement:0,HTMLSelectElement:0,MediaList:0,MimeTypeArray:0,NamedNodeMap:0,NodeList:1,PaintRequestList:0,Plugin:0,PluginArray:0,SVGLengthList:0,SVGNumberList:0,SVGPathSegList:0,SVGPointList:0,SVGStringList:0,SVGTransformList:0,SourceBufferList:0,StyleSheetList:0,TextTrackCueList:0,TextTrackList:0,TouchList:0}},function(t,e,n){"use strict";var r=n(15),o=n(88),i=n(12),u=n(9),c=n(39),a=u.set,s=u.getterFor("Array Iterator");t.exports=c(Array,"Array",(function(t,e){a(this,{type:"Array Iterator",target:r(t),index:0,kind:e})}),(function(){var t=s(this),e=t.target,n=t.kind,r=t.index++;return!e||r>=e.length?(t.target=void 0,{value:void 0,done:!0}):"keys"==n?{value:r,done:!1}:"values"==n?{value:e[r],done:!1}:{value:[r,e[r]],done:!1}}),"values"),i.Arguments=i.Array,o("keys"),o("values"),o("entries")},function(t,e,n){var r=n(1),o=n(37),i=n(5),u=r("unscopables"),c=Array.prototype;null==c[u]&&i.f(c,u,{configurable:!0,value:o(null)}),t.exports=function(t){c[u][t]=!0}},function(t,e,n){n(90),n(40),n(41),n(42);var r=n(10);t.exports=r.Set},function(t,e,n){"use strict";var r=n(21),o=n(61);t.exports=r("Set",(function(t){return function(){return t(this,arguments.length?arguments[0]:void 0)}}),o)},function(t,e,n){n(40),n(92),n(42);var r=n(10);t.exports=r.WeakMap},function(t,e,n){"use strict";var r,o=n(0),i=n(38),u=n(18),c=n(21),a=n(93),s=n(2),f=n(9).enforce,l=n(49),p=!o.ActiveXObject&&"ActiveXObject"in o,h=Object.isExtensible,d=function(t){return function(){return t(this,arguments.length?arguments[0]:void 0)}},v=t.exports=c("WeakMap",d,a);if(l&&p){r=a.getConstructor(d,"WeakMap",!0),u.REQUIRED=!0;var y=v.prototype,m=y.delete,g=y.has,x=y.get,b=y.set;i(y,{delete:function(t){if(s(t)&&!h(t)){var e=f(this);return e.frozen||(e.frozen=new r),m.call(this,t)||e.frozen.delete(t)}return m.call(this,t)},has:function(t){if(s(t)&&!h(t)){var e=f(this);return e.frozen||(e.frozen=new r),g.call(this,t)||e.frozen.has(t)}return g.call(this,t)},get:function(t){if(s(t)&&!h(t)){var e=f(this);return e.frozen||(e.frozen=new r),g.call(this,t)?x.call(this,t):e.frozen.get(t)}return x.call(this,t)},set:function(t,e){if(s(t)&&!h(t)){var n=f(this);n.frozen||(n.frozen=new r),g.call(this,t)?b.call(this,t,e):n.frozen.set(t,e)}else b.call(this,t,e);return this}})}},function(t,e,n){"use strict";var r=n(38),o=n(18).getWeakData,i=n(7),u=n(2),c=n(35),a=n(33),s=n(94),f=n(3),l=n(9),p=l.set,h=l.getterFor,d=s.find,v=s.findIndex,y=0,m=function(t){return t.frozen||(t.frozen=new g)},g=function(){this.entries=[]},x=function(t,e){return d(t.entries,(function(t){return t[0]===e}))};g.prototype={get:function(t){var e=x(this,t);if(e)return e[1]},has:function(t){return!!x(this,t)},set:function(t,e){var n=x(this,t);n?n[1]=e:this.entries.push([t,e])},delete:function(t){var e=v(this.entries,(function(e){return e[0]===t}));return~e&&this.entries.splice(e,1),!!~e}},t.exports={getConstructor:function(t,e,n,s){var l=t((function(t,r){c(t,l,e),p(t,{type:e,id:y++,frozen:void 0}),null!=r&&a(r,t[s],t,n)})),d=h(e),v=function(t,e,n){var r=d(t),u=o(i(e),!0);return!0===u?m(r).set(e,n):u[r.id]=n,t};return r(l.prototype,{delete:function(t){var e=d(this);if(!u(t))return!1;var n=o(t);return!0===n?m(e).delete(t):n&&f(n,e.id)&&delete n[e.id]},has:function(t){var e=d(this);if(!u(t))return!1;var n=o(t);return!0===n?m(e).has(t):n&&f(n,e.id)}}),r(l.prototype,n?{get:function(t){var e=d(this);if(u(t)){var n=o(t);return!0===n?m(e).get(t):n?n[e.id]:void 0}},set:function(t,e){return v(this,t,e)}}:{add:function(t){return v(this,t,!0)}}),l}}},function(t,e,n){var r=n(19),o=n(22),i=n(20),u=n(17),c=n(95),a=[].push,s=function(t){var e=1==t,n=2==t,s=3==t,f=4==t,l=6==t,p=5==t||l;return function(h,d,v,y){for(var m,g,x=i(h),b=o(x),w=r(d,v,3),S=u(b.length),_=0,E=y||c,O=e?E(h,S):n?E(h,0):void 0;S>_;_++)if((p||_ in b)&&(g=w(m=b[_],_,x),t))if(e)O[_]=g;else if(g)switch(t){case 3:return!0;case 5:return m;case 6:return _;case 2:a.call(O,m)}else if(f)return!1;return l?-1:s||f?f:O}};t.exports={forEach:s(0),map:s(1),filter:s(2),some:s(3),every:s(4),find:s(5),findIndex:s(6)}},function(t,e,n){var r=n(2),o=n(96),i=n(1)("species");t.exports=function(t,e){var n;return o(t)&&("function"!=typeof(n=t.constructor)||n!==Array&&!o(n.prototype)?r(n)&&null===(n=n[i])&&(n=void 0):n=void 0),new(void 0===n?Array:n)(0===e?0:e)}},function(t,e,n){var r=n(23);t.exports=Array.isArray||function(t){return"Array"==r(t)}},function(t,e,n){n(41),n(98);var r=n(10);t.exports=r.Array.from},function(t,e,n){var r=n(13),o=n(99);r({target:"Array",stat:!0,forced:!n(59)((function(t){Array.from(t)}))},{from:o})},function(t,e,n){"use strict";var r=n(19),o=n(20),i=n(58),u=n(54),c=n(17),a=n(100),s=n(56);t.exports=function(t){var e,n,f,l,p,h,d=o(t),v="function"==typeof this?this:Array,y=arguments.length,m=y>1?arguments[1]:void 0,g=void 0!==m,x=s(d),b=0;if(g&&(m=r(m,y>2?arguments[2]:void 0,2)),null==x||v==Array&&u(x))for(n=new v(e=c(d.length));e>b;b++)h=g?m(d[b],b):d[b],a(n,b,h);else for(p=(l=x.call(d)).next,n=new v;!(f=p.call(l)).done;b++)h=g?i(l,m,[f.value,b],!0):f.value,a(n,b,h);return n.length=b,n}},function(t,e,n){"use strict";var r=n(25),o=n(5),i=n(14);t.exports=function(t,e,n){var u=r(e);u in t?o.f(t,u,i(0,n)):t[u]=n}},function(t,e,n){n(102);var r=n(10);t.exports=r.Object.assign},function(t,e,n){var r=n(13),o=n(103);r({target:"Object",stat:!0,forced:Object.assign!==o},{assign:o})},function(t,e,n){"use strict";var r=n(6),o=n(4),i=n(62),u=n(52),c=n(44),a=n(20),s=n(22),f=Object.assign,l=Object.defineProperty;t.exports=!f||o((function(){if(r&&1!==f({b:1},f(l({},"a",{enumerable:!0,get:function(){l(this,"b",{value:3,enumerable:!1})}}),{b:2})).b)return!0;var t={},e={},n=Symbol();return t[n]=7,"abcdefghijklmnopqrst".split("").forEach((function(t){e[t]=t})),7!=f({},t)[n]||"abcdefghijklmnopqrst"!=i(f({},e)).join("")}))?function(t,e){for(var n=a(t),o=arguments.length,f=1,l=u.f,p=c.f;o>f;)for(var h,d=s(arguments[f++]),v=l?i(d).concat(l(d)):i(d),y=v.length,m=0;y>m;)h=v[m++],r&&!p.call(d,h)||(n[h]=d[h]);return n}:f},function(t,e,n){"use strict";n.r(e);var r={};n.r(r),n.d(r,"keyboardHandler",(function(){return I})),n.d(r,"mouseHandler",(function(){return R})),n.d(r,"resizeHandler",(function(){return C})),n.d(r,"selectHandler",(function(){return N})),n.d(r,"touchHandler",(function(){return F})),n.d(r,"wheelHandler",(function(){return H}));
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var o=function(t,e){return(o=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])})(t,e)},i=function(){return(i=Object.assign||function(t){for(var e,n=1,r=arguments.length;n<r;n++)for(var o in e=arguments[n])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)};function u(t,e,n,r){var o,i=arguments.length,u=i<3?e:null===r?r=Object.getOwnPropertyDescriptor(e,n):r;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)u=Reflect.decorate(t,e,n,r);else for(var c=t.length-1;c>=0;c--)(o=t[c])&&(u=(i<3?o(u):i>3?o(e,n,u):o(e,n))||u);return i>3&&u&&Object.defineProperty(e,n,u),u}n(66),n(89),n(91),n(97),n(101);var c,a=new WeakMap;function s(){if(void 0!==c)return c;var t=!1;try{var e=function(){},n=Object.defineProperty({},"passive",{enumerable:!0,get:function(){return t=!0,!0}});window.addEventListener("testPassive",e,n),window.removeEventListener("testPassive",e,n)}catch(t){}return c=!!t&&{passive:!1}}function f(t){var e=a.get(t)||[];return a.set(t,e),function(t,n,r){function o(t){t.defaultPrevented||r(t)}n.split(/\s+/g).forEach((function(n){e.push({elem:t,eventName:n,handler:o}),t.addEventListener(n,o,s())}))}}function l(t){var e=function(t){return t.touches?t.touches[t.touches.length-1]:t}(t);return{x:e.clientX,y:e.clientY}}function p(t,e){return void 0===e&&(e=[]),e.some((function(e){return t===e}))}var h=["webkit","moz","ms","o"],d=new RegExp("^-(?!(?:"+h.join("|")+")-)");function v(t,e){e=function(t){var e={};return Object.keys(t).forEach((function(n){if(d.test(n)){var r=t[n];n=n.replace(/^-/,""),e[n]=r,h.forEach((function(t){e["-"+t+"-"+n]=r}))}else e[n]=t[n]})),e}(e),Object.keys(e).forEach((function(n){var r=n.replace(/^-/,"").replace(/-([a-z])/g,(function(t,e){return e.toUpperCase()}));t.style[r]=e[n]}))}var y=function(){function t(t){this.velocityMultiplier=window.devicePixelRatio,this.updateTime=Date.now(),this.delta={x:0,y:0},this.velocity={x:0,y:0},this.lastPosition={x:0,y:0},this.lastPosition=l(t)}return t.prototype.update=function(t){var e=this.velocity,n=this.updateTime,r=this.lastPosition,o=Date.now(),i=l(t),u={x:-(i.x-r.x),y:-(i.y-r.y)},c=o-n||16.7,a=u.x/c*16.7,s=u.y/c*16.7;e.x=a*this.velocityMultiplier,e.y=s*this.velocityMultiplier,this.delta=u,this.updateTime=o,this.lastPosition=i},t}(),m=function(){function t(){this._touchList={}}return Object.defineProperty(t.prototype,"_primitiveValue",{get:function(){return{x:0,y:0}},enumerable:!0,configurable:!0}),t.prototype.isActive=function(){return void 0!==this._activeTouchID},t.prototype.getDelta=function(){var t=this._getActiveTracker();return t?i({},t.delta):this._primitiveValue},t.prototype.getVelocity=function(){var t=this._getActiveTracker();return t?i({},t.velocity):this._primitiveValue},t.prototype.getEasingDistance=function(t){var e=1-t,n={x:0,y:0},r=this.getVelocity();return Object.keys(r).forEach((function(t){for(var o=Math.abs(r[t])<=10?0:r[t];0!==o;)n[t]+=o,o=o*e|0})),n},t.prototype.track=function(t){var e=this,n=t.targetTouches;return Array.from(n).forEach((function(t){e._add(t)})),this._touchList},t.prototype.update=function(t){var e=this,n=t.touches,r=t.changedTouches;return Array.from(n).forEach((function(t){e._renew(t)})),this._setActiveID(r),this._touchList},t.prototype.release=function(t){var e=this;delete this._activeTouchID,Array.from(t.changedTouches).forEach((function(t){e._delete(t)}))},t.prototype._add=function(t){this._has(t)&&this._delete(t);var e=new y(t);this._touchList[t.identifier]=e},t.prototype._renew=function(t){this._has(t)&&this._touchList[t.identifier].update(t)},t.prototype._delete=function(t){delete this._touchList[t.identifier]},t.prototype._has=function(t){return this._touchList.hasOwnProperty(t.identifier)},t.prototype._setActiveID=function(t){this._activeTouchID=t[t.length-1].identifier},t.prototype._getActiveTracker=function(){return this._touchList[this._activeTouchID]},t}();function g(t,e,n){return Math.max(e,Math.min(n,t))}function x(t,e,n){var r;void 0===e&&(e=0);var o=-1/0;return function(){for(var i=this,u=[],c=0;c<arguments.length;c++)u[c]=arguments[c];if(n){var a=Date.now(),s=a-o;o=a,s>=e&&t.apply(this,u),clearTimeout(r),r=setTimeout((function(){t.apply(i,u)}),e)}}}function b(t,e){return void 0===t&&(t=-1/0),void 0===e&&(e=1/0),function(n,r){var o="_"+r;Object.defineProperty(n,r,{get:function(){return this[o]},set:function(n){Object.defineProperty(this,o,{value:g(n,t,e),enumerable:!1,writable:!0,configurable:!0})},enumerable:!0,configurable:!0})}}function w(t,e){var n="_"+e;Object.defineProperty(t,e,{get:function(){return this[n]},set:function(t){Object.defineProperty(this,n,{value:!!t,enumerable:!1,writable:!0,configurable:!0})},enumerable:!0,configurable:!0})}function S(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];return function(e,n,r){var o=r.value;return{get:function(){return this.hasOwnProperty(n)||Object.defineProperty(this,n,{value:x.apply(void 0,function(){for(var t=0,e=0,n=arguments.length;e<n;e++)t+=arguments[e].length;var r=Array(t),o=0;for(e=0;e<n;e++)for(var i=arguments[e],u=0,c=i.length;u<c;u++,o++)r[o]=i[u];return r}([o],t))}),this[n]}}}}var _,E=function(){function t(t){var e=this;void 0===t&&(t={}),this.damping=.1,this.thumbMinSize=20,this.renderByPixels=!0,this.alwaysShowTracks=!1,this.continuousScrolling=!0,this.delegateTo=null,this.plugins={},Object.keys(t).forEach((function(n){e[n]=t[n]}))}return Object.defineProperty(t.prototype,"wheelEventTarget",{get:function(){return this.delegateTo},set:function(t){console.warn("[smooth-scrollbar]: `options.wheelEventTarget` is deprecated and will be removed in the future, use `options.delegateTo` instead."),this.delegateTo=t},enumerable:!0,configurable:!0}),u([b(0,1)],t.prototype,"damping",void 0),u([b(0,1/0)],t.prototype,"thumbMinSize",void 0),u([w],t.prototype,"renderByPixels",void 0),u([w],t.prototype,"alwaysShowTracks",void 0),u([w],t.prototype,"continuousScrolling",void 0),t}();!function(t){t.X="x",t.Y="y"}(_||(_={}));var O=function(){function t(t,e){void 0===e&&(e=0),this._direction=t,this._minSize=e,this.element=document.createElement("div"),this.displaySize=0,this.realSize=0,this.offset=0,this.element.className="scrollbar-thumb scrollbar-thumb-"+t}return t.prototype.attachTo=function(t){t.appendChild(this.element)},t.prototype.update=function(t,e,n){this.realSize=Math.min(e/n,1)*e,this.displaySize=Math.max(this.realSize,this._minSize),this.offset=t/n*(e+(this.realSize-this.displaySize)),v(this.element,this._getStyle())},t.prototype._getStyle=function(){switch(this._direction){case _.X:return{width:this.displaySize+"px","-transform":"translate3d("+this.offset+"px, 0, 0)"};case _.Y:return{height:this.displaySize+"px","-transform":"translate3d(0, "+this.offset+"px, 0)"};default:return null}},t}(),T=function(){function t(t,e){void 0===e&&(e=0),this.element=document.createElement("div"),this._isShown=!1,this.element.className="scrollbar-track scrollbar-track-"+t,this.thumb=new O(t,e),this.thumb.attachTo(this.element)}return t.prototype.attachTo=function(t){t.appendChild(this.element)},t.prototype.show=function(){this._isShown||(this._isShown=!0,this.element.classList.add("show"))},t.prototype.hide=function(){this._isShown&&(this._isShown=!1,this.element.classList.remove("show"))},t.prototype.update=function(t,e,n){v(this.element,{display:n<=e?"none":"block"}),this.thumb.update(t,e,n)},t}(),A=function(){function t(t){this._scrollbar=t;var e=t.options.thumbMinSize;this.xAxis=new T(_.X,e),this.yAxis=new T(_.Y,e),this.xAxis.attachTo(t.containerEl),this.yAxis.attachTo(t.containerEl),t.options.alwaysShowTracks&&(this.xAxis.show(),this.yAxis.show())}return t.prototype.update=function(){var t=this._scrollbar,e=t.size,n=t.offset;this.xAxis.update(n.x,e.container.width,e.content.width),this.yAxis.update(n.y,e.container.height,e.content.height)},t.prototype.autoHideOnIdle=function(){this._scrollbar.options.alwaysShowTracks||(this.xAxis.hide(),this.yAxis.hide())},u([S(300)],t.prototype,"autoHideOnIdle",null),t}(),P=new WeakMap;function j(t){return Math.pow(t-1,3)+1}var M,k,D,z=function(){function t(t,e){var n=this.constructor;this.scrollbar=t,this.name=n.pluginName,this.options=i(i({},n.defaultOptions),e)}return t.prototype.onInit=function(){},t.prototype.onDestroy=function(){},t.prototype.onUpdate=function(){},t.prototype.onRender=function(t){},t.prototype.transformDelta=function(t,e){return i({},t)},t.pluginName="",t.defaultOptions={},t}(),L={order:new Set,constructors:{}};function I(t){var e=f(t),n=t.containerEl;e(n,"keydown",(function(e){var r=document.activeElement;if((r===n||n.contains(r))&&!function(t){return!("INPUT"!==t.tagName&&"SELECT"!==t.tagName&&"TEXTAREA"!==t.tagName&&!t.isContentEditable)&&!t.disabled}(r)){var o=function(t,e){var n=t.size,r=t.limit,o=t.offset;switch(e){case M.TAB:return function(t){requestAnimationFrame((function(){t.scrollIntoView(document.activeElement,{offsetTop:t.size.container.height/2,offsetLeft:t.size.container.width/2,onlyScrollIfNeeded:!0})}))}(t);case M.SPACE:return[0,200];case M.PAGE_UP:return[0,40-n.container.height];case M.PAGE_DOWN:return[0,n.container.height-40];case M.END:return[0,r.y-o.y];case M.HOME:return[0,-o.y];case M.LEFT:return[-40,0];case M.UP:return[0,-40];case M.RIGHT:return[40,0];case M.DOWN:return[0,40];default:return null}}(t,e.keyCode||e.which);if(o){var i=o[0],u=o[1];t.addTransformableMomentum(i,u,e,(function(n){n?e.preventDefault():(t.containerEl.blur(),t.parent&&t.parent.containerEl.focus())}))}}}))}function R(t){var e,n,r,o,i,u=f(t),c=t.containerEl,a=t.track,s=a.xAxis,h=a.yAxis;function d(e,n){var r=t.size,o=t.limit,i=t.offset;return e===k.X?g(n/(r.container.width+(s.thumb.realSize-s.thumb.displaySize))*r.content.width,0,o.x)-i.x:e===k.Y?g(n/(r.container.height+(h.thumb.realSize-h.thumb.displaySize))*r.content.height,0,o.y)-i.y:0}function y(t){return p(t,[s.element,s.thumb.element])?k.X:p(t,[h.element,h.thumb.element])?k.Y:void 0}u(c,"click",(function(e){if(!n&&p(e.target,[s.element,h.element])){var r=e.target,o=y(r),i=r.getBoundingClientRect(),u=l(e);if(o===k.X){var c=u.x-i.left-s.thumb.displaySize/2;t.setMomentum(d(o,c),0)}o===k.Y&&(c=u.y-i.top-h.thumb.displaySize/2,t.setMomentum(0,d(o,c)))}})),u(c,"mousedown",(function(n){if(p(n.target,[s.thumb.element,h.thumb.element])){e=!0;var u=n.target,a=l(n),f=u.getBoundingClientRect();o=y(u),r={x:a.x-f.left,y:a.y-f.top},i=c.getBoundingClientRect(),v(t.containerEl,{"-user-select":"none"})}})),u(window,"mousemove",(function(u){if(e){n=!0;var c=l(u);if(o===k.X){var a=c.x-r.x-i.left;t.setMomentum(d(o,a),0)}o===k.Y&&(a=c.y-r.y-i.top,t.setMomentum(0,d(o,a)))}})),u(window,"mouseup blur",(function(){e=n=!1,v(t.containerEl,{"-user-select":""})}))}function C(t){f(t)(window,"resize",x(t.update.bind(t),300))}function N(t){var e,n=f(t),r=t.containerEl,o=t.contentEl,i=!1,u=!1;n(window,"mousemove",(function(n){i&&(cancelAnimationFrame(e),function n(r){var o=r.x,i=r.y;if(o||i){var u=t.offset,c=t.limit;t.setMomentum(g(u.x+o,0,c.x)-u.x,g(u.y+i,0,c.y)-u.y),e=requestAnimationFrame((function(){n({x:o,y:i})}))}}(function(t,e){var n=t.bounding,r=n.top,o=n.right,i=n.bottom,u=n.left,c=l(e),a=c.x,s=c.y,f={x:0,y:0};return 0===a&&0===s||(a>o-20?f.x=a-o+20:a<u+20&&(f.x=a-u-20),s>i-20?f.y=s-i+20:s<r+20&&(f.y=s-r-20),f.x*=2,f.y*=2),f}(t,n)))})),n(o,"contextmenu",(function(){u=!0,cancelAnimationFrame(e),i=!1})),n(o,"mousedown",(function(){u=!1})),n(o,"selectstart",(function(){u||(cancelAnimationFrame(e),i=!0)})),n(window,"mouseup blur",(function(){cancelAnimationFrame(e),i=!1,u=!1})),n(r,"scroll",(function(t){t.preventDefault(),r.scrollTop=r.scrollLeft=0}))}function F(t){var e,n=t.options.delegateTo||t.containerEl,r=new m,o=f(t),i=0;o(n,"touchstart",(function(n){r.track(n),t.setMomentum(0,0),0===i&&(e=t.options.damping,t.options.damping=Math.max(e,.5)),i++})),o(n,"touchmove",(function(e){if(!D||D===t){r.update(e);var n=r.getDelta(),o=n.x,i=n.y;t.addTransformableMomentum(o,i,e,(function(n){n&&e.cancelable&&(e.preventDefault(),D=t)}))}})),o(n,"touchcancel touchend",(function(n){var o=r.getEasingDistance(e);t.addTransformableMomentum(o.x,o.y,n),0==--i&&(t.options.damping=e),r.release(n),D=null}))}function H(t){f(t)(t.options.delegateTo||t.containerEl,"onwheel"in window||document.implementation.hasFeature("Events.wheel","3.0")?"wheel":"mousewheel",(function(e){var n=function(t){if("deltaX"in t){var e=G(t.deltaMode);return{x:t.deltaX/W.STANDARD*e,y:t.deltaY/W.STANDARD*e}}return"wheelDeltaX"in t?{x:t.wheelDeltaX/W.OTHERS,y:t.wheelDeltaY/W.OTHERS}:{x:0,y:t.wheelDelta/W.OTHERS}}(e),r=n.x,o=n.y;t.addTransformableMomentum(r,o,e,(function(t){t&&e.preventDefault()}))}))}!function(t){t[t.TAB=9]="TAB",t[t.SPACE=32]="SPACE",t[t.PAGE_UP=33]="PAGE_UP",t[t.PAGE_DOWN=34]="PAGE_DOWN",t[t.END=35]="END",t[t.HOME=36]="HOME",t[t.LEFT=37]="LEFT",t[t.UP=38]="UP",t[t.RIGHT=39]="RIGHT",t[t.DOWN=40]="DOWN"}(M||(M={})),function(t){t[t.X=0]="X",t[t.Y=1]="Y"}(k||(k={}));var W={STANDARD:1,OTHERS:-3},B=[1,28,500],G=function(t){return B[t]||B[0]},X=new Map,U=function(){function t(t,e){var n=this;this.offset={x:0,y:0},this.limit={x:1/0,y:1/0},this.bounding={top:0,right:0,bottom:0,left:0},this._plugins=[],this._momentum={x:0,y:0},this._listeners=new Set,this.containerEl=t;var r=this.contentEl=document.createElement("div");this.options=new E(e),t.setAttribute("data-scrollbar","true"),t.setAttribute("tabindex","-1"),v(t,{overflow:"hidden",outline:"none"}),window.navigator.msPointerEnabled&&(t.style.msTouchAction="none"),r.className="scroll-content",Array.from(t.childNodes).forEach((function(t){r.appendChild(t)})),t.appendChild(r),this.track=new A(this),this.size=this.getSize(),this._plugins=function(t,e){return Array.from(L.order).filter((function(t){return!1!==e[t]})).map((function(n){var r=new(0,L.constructors[n])(t,e[n]);return e[n]=r.options,r}))}(this,this.options.plugins);var o=t.scrollLeft,i=t.scrollTop;t.scrollLeft=t.scrollTop=0,this.setPosition(o,i,{withoutCallbacks:!0});var u=window.ResizeObserver;"function"==typeof u&&(this._observer=new u((function(){n.update()})),this._observer.observe(r)),X.set(t,this),requestAnimationFrame((function(){n._init()}))}return Object.defineProperty(t.prototype,"parent",{get:function(){for(var t=this.containerEl.parentElement;t;){var e=X.get(t);if(e)return e;t=t.parentElement}return null},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"scrollTop",{get:function(){return this.offset.y},set:function(t){this.setPosition(this.scrollLeft,t)},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"scrollLeft",{get:function(){return this.offset.x},set:function(t){this.setPosition(t,this.scrollTop)},enumerable:!0,configurable:!0}),t.prototype.getSize=function(){return function(t){var e=t.containerEl,n=t.contentEl,r=getComputedStyle(e),o=["paddingTop","paddingBottom","paddingLeft","paddingRight"].map((function(t){return r[t]?parseFloat(r[t]):0})),i=o[0]+o[1],u=o[2]+o[3];return{container:{width:e.clientWidth,height:e.clientHeight},content:{width:n.offsetWidth-n.clientWidth+n.scrollWidth+u,height:n.offsetHeight-n.clientHeight+n.scrollHeight+i}}}(this)},t.prototype.update=function(){!function(t){var e=t.getSize(),n={x:Math.max(e.content.width-e.container.width,0),y:Math.max(e.content.height-e.container.height,0)},r=t.containerEl.getBoundingClientRect(),o={top:Math.max(r.top,0),right:Math.min(r.right,window.innerWidth),bottom:Math.min(r.bottom,window.innerHeight),left:Math.max(r.left,0)};t.size=e,t.limit=n,t.bounding=o,t.track.update(),t.setPosition()}(this),this._plugins.forEach((function(t){t.onUpdate()}))},t.prototype.isVisible=function(t){return function(t,e){var n=t.bounding,r=e.getBoundingClientRect(),o=Math.max(n.top,r.top),i=Math.max(n.left,r.left),u=Math.min(n.right,r.right);return o<Math.min(n.bottom,r.bottom)&&i<u}(this,t)},t.prototype.setPosition=function(t,e,n){var r=this;void 0===t&&(t=this.offset.x),void 0===e&&(e=this.offset.y),void 0===n&&(n={});var o=function(t,e,n){var r=t.options,o=t.offset,u=t.limit,c=t.track,a=t.contentEl;return r.renderByPixels&&(e=Math.round(e),n=Math.round(n)),e=g(e,0,u.x),n=g(n,0,u.y),e!==o.x&&c.xAxis.show(),n!==o.y&&c.yAxis.show(),r.alwaysShowTracks||c.autoHideOnIdle(),e===o.x&&n===o.y?null:(o.x=e,o.y=n,v(a,{"-transform":"translate3d("+-e+"px, "+-n+"px, 0)"}),c.update(),{offset:i({},o),limit:i({},u)})}(this,t,e);o&&!n.withoutCallbacks&&this._listeners.forEach((function(t){t.call(r,o)}))},t.prototype.scrollTo=function(t,e,n,r){void 0===t&&(t=this.offset.x),void 0===e&&(e=this.offset.y),void 0===n&&(n=0),void 0===r&&(r={}),function(t,e,n,r,o){void 0===r&&(r=0);var i=void 0===o?{}:o,u=i.easing,c=void 0===u?j:u,a=i.callback,s=t.options,f=t.offset,l=t.limit;s.renderByPixels&&(e=Math.round(e),n=Math.round(n));var p=f.x,h=f.y,d=g(e,0,l.x)-p,v=g(n,0,l.y)-h,y=Date.now();cancelAnimationFrame(P.get(t)),function e(){var n=Date.now()-y,o=r?c(Math.min(n/r,1)):1;if(t.setPosition(p+d*o,h+v*o),n>=r)"function"==typeof a&&a.call(t);else{var i=requestAnimationFrame(e);P.set(t,i)}}()}(this,t,e,n,r)},t.prototype.scrollIntoView=function(t,e){void 0===e&&(e={}),function(t,e,n){var r=void 0===n?{}:n,o=r.alignToTop,i=void 0===o||o,u=r.onlyScrollIfNeeded,c=void 0!==u&&u,a=r.offsetTop,s=void 0===a?0:a,f=r.offsetLeft,l=void 0===f?0:f,p=r.offsetBottom,h=void 0===p?0:p,d=t.containerEl,v=t.bounding,y=t.offset,m=t.limit;if(e&&d.contains(e)){var x=e.getBoundingClientRect();if(!c||!t.isVisible(e)){var b=i?x.top-v.top-s:x.bottom-v.bottom+h;t.setMomentum(x.left-v.left-l,g(b,-y.y,m.y-y.y))}}}(this,t,e)},t.prototype.addListener=function(t){if("function"!=typeof t)throw new TypeError("[smooth-scrollbar] scrolling listener should be a function");this._listeners.add(t)},t.prototype.removeListener=function(t){this._listeners.delete(t)},t.prototype.addTransformableMomentum=function(t,e,n,r){this._updateDebounced();var o=this._plugins.reduce((function(t,e){return e.transformDelta(t,n)||t}),{x:t,y:e}),i=!this._shouldPropagateMomentum(o.x,o.y);i&&this.addMomentum(o.x,o.y),r&&r.call(this,i)},t.prototype.addMomentum=function(t,e){this.setMomentum(this._momentum.x+t,this._momentum.y+e)},t.prototype.setMomentum=function(t,e){0===this.limit.x&&(t=0),0===this.limit.y&&(e=0),this.options.renderByPixels&&(t=Math.round(t),e=Math.round(e)),this._momentum.x=t,this._momentum.y=e},t.prototype.updatePluginOptions=function(t,e){this._plugins.forEach((function(n){n.name===t&&Object.assign(n.options,e)}))},t.prototype.destroy=function(){var t=this.containerEl,e=this.contentEl;!function(t){var e=a.get(t);e&&(e.forEach((function(t){var e=t.elem,n=t.eventName,r=t.handler;e.removeEventListener(n,r,s())})),a.delete(t))}(this),this._listeners.clear(),this.setMomentum(0,0),cancelAnimationFrame(this._renderID),this._observer&&this._observer.disconnect(),X.delete(this.containerEl);for(var n=Array.from(e.childNodes);t.firstChild;)t.removeChild(t.firstChild);n.forEach((function(e){t.appendChild(e)})),v(t,{overflow:""}),t.scrollTop=this.scrollTop,t.scrollLeft=this.scrollLeft,this._plugins.forEach((function(t){t.onDestroy()})),this._plugins.length=0},t.prototype._init=function(){var t=this;this.update(),Object.keys(r).forEach((function(e){r[e](t)})),this._plugins.forEach((function(t){t.onInit()})),this._render()},t.prototype._updateDebounced=function(){this.update()},t.prototype._shouldPropagateMomentum=function(t,e){void 0===t&&(t=0),void 0===e&&(e=0);var n=this.options,r=this.offset,o=this.limit;if(!n.continuousScrolling)return!1;0===o.x&&0===o.y&&this._updateDebounced();var i=g(t+r.x,0,o.x),u=g(e+r.y,0,o.y),c=!0;return(c=(c=c&&i===r.x)&&u===r.y)&&(r.x===o.x||0===r.x||r.y===o.y||0===r.y)},t.prototype._render=function(){var t=this._momentum;if(t.x||t.y){var e=this._nextTick("x"),n=this._nextTick("y");t.x=e.momentum,t.y=n.momentum,this.setPosition(e.position,n.position)}var r=i({},this._momentum);this._plugins.forEach((function(t){t.onRender(r)})),this._renderID=requestAnimationFrame(this._render.bind(this))},t.prototype._nextTick=function(t){var e=this.options,n=this.offset,r=this._momentum,o=n[t],i=r[t];if(Math.abs(i)<=.1)return{momentum:0,position:o+i};var u=i*(1-e.damping);return e.renderByPixels&&(u|=0),{momentum:u,position:o+i-u}},u([S(100,!0)],t.prototype,"_updateDebounced",null),t}(),V="smooth-scrollbar-style",Y=!1;function q(){if(!Y&&"undefined"!=typeof window){var t=document.createElement("style");t.id=V,t.textContent="\n[data-scrollbar] {\n  display: block;\n  position: relative;\n}\n\n.scroll-content {\n  display: flow-root;\n  -webkit-transform: translate3d(0, 0, 0);\n          transform: translate3d(0, 0, 0);\n}\n\n.scrollbar-track {\n  position: absolute;\n  opacity: 0;\n  z-index: 1;\n  background: rgba(222, 222, 222, .75);\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  -webkit-transition: opacity 0.5s 0.5s ease-out;\n          transition: opacity 0.5s 0.5s ease-out;\n}\n.scrollbar-track.show,\n.scrollbar-track:hover {\n  opacity: 1;\n  -webkit-transition-delay: 0s;\n          transition-delay: 0s;\n}\n\n.scrollbar-track-x {\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 8px;\n}\n.scrollbar-track-y {\n  top: 0;\n  right: 0;\n  width: 8px;\n  height: 100%;\n}\n.scrollbar-thumb {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 8px;\n  height: 8px;\n  background: rgba(0, 0, 0, .5);\n  border-radius: 4px;\n}\n",document.head&&document.head.appendChild(t),Y=!0}}n.d(e,"ScrollbarPlugin",(function(){return z}));var Q=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return function(t,e){function n(){this.constructor=t}o(t,e),t.prototype=null===e?Object.create(e):(n.prototype=e.prototype,new n)}(e,t),e.init=function(t,e){if(!t||1!==t.nodeType)throw new TypeError("expect element to be DOM Element, but got "+t);return q(),X.has(t)?X.get(t):new U(t,e)},e.initAll=function(t){return Array.from(document.querySelectorAll("[data-scrollbar]"),(function(n){return e.init(n,t)}))},e.has=function(t){return X.has(t)},e.get=function(t){return X.get(t)},e.getAll=function(){return Array.from(X.values())},e.destroy=function(t){var e=X.get(t);e&&e.destroy()},e.destroyAll=function(){X.forEach((function(t){t.destroy()}))},e.use=function(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];return function(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];t.forEach((function(t){var e=t.pluginName;if(!e)throw new TypeError("plugin name is required");L.order.add(e),L.constructors[e]=t}))}.apply(void 0,t)},e.attachStyle=function(){return q()},e.detachStyle=function(){return function(){if(Y&&"undefined"!=typeof window){var t=document.getElementById(V);t&&t.parentNode&&(t.parentNode.removeChild(t),Y=!1)}}()},e.version="8.8.3",e.ScrollbarPlugin=z,e}(U);e.default=Q}]).default}));
document.addEventListener("touchstart", function () { }, true);

// На сколько проскролили страницу
function getBodyScrollTop() {
    return self.pageYOffset || (document.documentElement && document.documentElement.scrollTop) || (document.body && document.body.scrollTop);
}
// Ширина скролбара
function getScrollbarWidth() {
    return window.innerWidth - document.documentElement.clientWidth;
}
// функция debounce
function debounce(func, time) {
    var timer;

    return function (args) {
        clearTimeout(timer);
        timer = setTimeout(function () { func(args) }, time);
    }
};

// Удаляем пробелы (разряд) у числа
function toNumber(str) {
    // console.log(typeof str);
    if (typeof str === 'string' || str instanceof String) {
        return str.split(' ').join('');
    } else {
        return str;
    }
}
// Добавляем пробелы (разряд) у числа
Number.prototype.toDivide = function () {
    var int = String(Math.trunc(this));
    if (int.length <= 3) return int;
    var space = 0;
    var number = '';
    for (var i = int.length - 1; i >= 0; i--) {
        if (space == 3) {
            number = ' ' + number;
            space = 0;
        }
        number = int.charAt(i) + number;
        space++;
    }
    return number;
}
// Проверяем евляется ли DOM элемент/объект
function name(el) {
    return el instanceof Element || el instanceof HTMLDocument;
}


// TODO Маска телефона
// VMasker(document.querySelectorAll('.input[type="tel"]')).maskPattern("9 (999) 999-99-99");
// VMasker(document.querySelectorAll('.js-date-time')).maskPattern("99.99.9999   99:99");
// VMasker(document.querySelectorAll('.js-date')).maskPattern("99.99.9999");
// VMasker(document.querySelectorAll('.js-birthday')).maskPattern("99.99.9999");
var maskaPhone = Maska.create('.input[type="tel"]', {
    mask: '+7 (###) ###-##-##',
    preprocessor: value => {
        var p = value.charAt(0) == 8 ? p = value.slice(1) : value;
        return p;
    }
});
// VMasker(document.querySelectorAll('.js-time')).maskPattern("99.99.9999   99:99");
// var maskaDateTime = Maska.create('.js-time', {
//     mask: '##:##'
// });
// VMasker(document.querySelectorAll('.js-date')).maskPattern("99.99.9999");
// var maskaDate = Maska.create('.js-date', {
//     mask: '##.##.####'
// });
// VMasker(document.querySelectorAll('.js-birthday')).maskPattern("99.99.9999");
// var maskaDate = Maska.create('.js-birthday', {
//     mask: '##.##.####'
// });

// TODO Составлем сегодняюнюю дату dd/mm/yyyy
// var
//     inputPhone = ".js-inputPhone",
//     js_date = ".js-date",
//     js_date_time = ".js-time",
//     now = new Date(),
//     month = (now.getMonth() + 1) < 10 ? "0" + (now.getMonth() + 1) : now.getMonth() + 1,
//     hours = now.getHours() + 1,
//     date = now.getDate() + "." + month + "." + now.getFullYear(),
//     today = now.getDate() < 10 ? "0" + now.getDate() : now.getDate(),
//     // dateTime = today + "." + month + "." + now.getFullYear() + "   " + hours + ":00";
//     dateTime = hours + ":00";

// TODO Указываем плэйсхолдер для все элементов .js-date и .js-time
// document.querySelectorAll(inputPhone).forEach(function (el) {
//     var startValue = el.placeholder;
//     if (el.placeholder == '.') { // проверяем есть ли placeholder по-умолчанию, если есть то меняем только при фокусе
//         el.addEventListener("focus", function () {
//             setTimeout(() => {
//                 this.placeholder = '+7 (___) ___-__-__';
//             }, 300);
//         });
//         el.addEventListener("blur", function () {
//             this.placeholder = startValue;
//         });
//     } else {
//         el.placeholder = '+7 (___) ___-__-__';
//     }
// });
// document.querySelectorAll(js_date).forEach(function (el) {
//     var startValue = el.placeholder;
//     if (el.placeholder == '.') { // проверяем есть ли placeholder по-умолчанию, если есть то меняем только при фокусе
//         el.addEventListener("focus", function () {
//             setTimeout(() => {
//                 this.placeholder = date;
//             }, 400);
//         });
//         el.addEventListener("blur", function () {
//             this.placeholder = startValue;
//         });
//     } else {
//         el.placeholder = date;
//     }
// });
// document.querySelectorAll(js_date_time).forEach(function (el) {
//     var startValue = el.placeholder;
//     if (el.placeholder) { // проверяем есть ли placeholder по-умолчанию, если есть то меняем только при фокусе
//         el.addEventListener("focus", function () {
//             setTimeout(() => {
//                 this.placeholder = dateTime;
//             }, 400);
//         });
//         el.addEventListener("blur", function () {
//             this.placeholder = startValue;
//         });
//     } else {
//         el.placeholder = dateTime;
//     }
// });


// TODO Bug-fix фиксированного меню и клавиатуры на Android
function chromeApp() {
    var vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', "".concat(vh, "px"));
}
// Запускаем функцию при изменении размера экрана
window.addEventListener('resize', function () {
    chromeApp();
});
// Определяем Android
if (navigator.userAgent.match(/android/i)) {
    document.querySelectorAll('.modal').forEach(function (el) {
        el.classList.add('android');
    });
    chromeApp();
}


// TODO Поднимаемся наверх
// var viewScrollUp = debounce(function () {
//     if (getBodyScrollTop() > 800) {
//         up.classList.add('active');
//     } else {
//         up.classList.remove('active');
//     }
// }, 500);
// if (document.querySelector('.js-up')) {
//     var up = document.querySelector('.js-up');
//     up.addEventListener('click', function () {
//         console.log(getBodyScrollTop());
//         skrollTop.scrollTo({
//             to: 0,
//             duration: 800
//         });
//         return false;
//     });
//     window.addEventListener("scroll", viewScrollUp);
// }


/*** ПЕРВОДИМ НА ОБЪЕКТЫ */
var MG = MG || {};


// TODO lighthouse
MG.lighthouse = {
    init: function () {
        return navigator.userAgent.indexOf("Lighthouse") === -1;
    }
}

// TODO message
MG.message = {
    processStart: function (e) {
        var process = e.querySelector('.message__process');
        process ? process.setAttribute('open', '') : '';
    },
    processEnd: function (e) {
        var process = e.querySelector('.message__process');
        process ? process.removeAttribute('open') : '';
    },
    message: function (e, msg, hide) {
        var hide = hide || false;
        if (msg) {
            var message = e.querySelector('.message');
            message ? message.setAttribute('open', '') : '';
            message ? message.innerHTML = msg : '';
            MG.message.processEnd(e);
            if (hide) {
                setTimeout(function () {
                    MG.message.clean(e);
                }, 2000);
            }
        }
    },
    error: function (e, msg) {
        var error = e.querySelector('.message__error');
        error ? error.innerHTML = msg : '';
        MG.message.processEnd(e);
    },
    clean: function (e) {
        var message = e.querySelector('.message'),
            error = e.querySelector('.message__error');
        message ? message.removeAttribute('open') : '';
        message ? message.innerHTML = '' : '';
        error ? error.removeAttribute('open') : '';
        error ? error.innerHTML = '' : '';
    },
    cleanInput: function (e) {
        var input = e.querySelectorAll('.input__send'),
            checkbox = e.querySelectorAll('.input__checkbox');
        input.forEach(function (el) {
            el.value = '';
        })
        checkbox.forEach(function (el) {
            el.checked = false;
        })
    }
}


// TODO validate
MG.validate = {
    search: function (e, names) {
        for (key in names) {
            var input = e.querySelector('input[name="' + key + '"]');
            input ? MG.validate.check(input, names[key]) : '';
        }
    },
    check: function (e, length) {
        if (typeof e.value != "undefined" && e.value.length < length) {
            e.classList.add('error');
        } else {
            e.classList.remove('error');
        }
    },
    searchAll: function (e, names) {
        for (key in names) {
            var input = e.querySelectorAll('input[' + key + ']');
            input ? MG.validate.checkAll(input, names[key]) : '';
        }
    },
    checkAll: function (e, length) {
        e.forEach(function (el) {
            if (typeof el.value != "undefined" && el.value.length < length) {
                el.classList.add('error');
            } else {
                el.classList.remove('error');
            }
        });
    }
}


// TODO nav
MG.nav = {
    init: function () {
        this.toggle();
        this.click();
        this.next();
        this.prev();
    },
    toggle: function () {
        var btn = document.querySelectorAll('.js-btnNav'),
            nav = document.querySelector('.js-nav');
        if (btn.length > 0) {
            btn.forEach(function (el) {
                el.addEventListener('click', function (e) {
                    e.preventDefault();
                    nav.toggleAttribute('open');
                })
            });
        }
    },
    click: function () {
        var nav = document.querySelector('.js-nav'),
            link = document.querySelectorAll('.js-link');
        if (link.length > 0) {
            link.forEach(function (el) {
                el.addEventListener('click', function (e) {
                    e.preventDefault();

                    nav.removeAttribute('open');

                    var id = this.getAttribute('href'),
                        section = document.querySelector(id)?.getBoundingClientRect(),
                        topScroll = getBodyScrollTop();
                    console.log(document.querySelector(id));
                    fixedHeader = document.querySelector('.js-fixed').offsetHeight;
                    // fixedHeader = 43; // только на моб и высота одна

                    // if (document.body.clientWidth < 670) {
                    //     var offset = section.top + topScroll - fixedHeader;
                    // } else {
                    //     var offset = section.top + topScroll;
                    // }

                    // if (id == '#about') {
                    //     fixedHeader = fixedHeader - 55;
                    // }

                    var offset = section.top + topScroll - fixedHeader;
                    // var offset = section.top + topScroll;

                    // window.scrollTo(0, offset);

                    skrollTop.scrollTo({
                        to: offset,
                        duration: 800
                    });
                    return false;
                })
            });
        }
    },
    next: function () {
        var parent = document.querySelector('.js-parentMenu'),
            info = document.querySelector('.js-infoMenu'),
            arr = document.querySelectorAll('.js-nextMenu');
        if (arr.length > 0) {
            arr.forEach(function (el) {
                el.addEventListener('click', function (e) {
                    e.preventDefault();

                    var num = e.target.getAttribute('data-sec');
                    parent.style.transform = "translateX(-" + num + "00%)";
                    info.style.transform = "translateX(-" + num + "10%)";
                    e.target.nextElementSibling.setAttribute('open', '');

                    return false;
                })
            });
        }
    },
    prev: function () {
        var parent = document.querySelector('.js-parentMenu'),
            info = document.querySelector('.js-infoMenu'),
            arr = document.querySelectorAll('.js-prevMenu');
        if (arr.length > 0) {
            arr.forEach(function (el) {
                el.addEventListener('click', function (e) {
                    e.preventDefault();

                    var num = e.target.getAttribute('data-sec');
                    parent.style.transform = "translateX(-" + num + "00%)";
                    info.style.transform = "translateX(-" + num + "00%)";
                    e.target.parentElement.removeAttribute('open');

                    return false;
                })
            });
        }
    }
}
MG.nav.init();


// TODO phone
// MG.phone = {
//     init: function () {
//         this.key();
//         this.change();
//     },
//     key: function () {
//         var phone = document.querySelectorAll('.input[type="tel"]');
//         if (phone.length > 0) {
//             phone.forEach(function (el) {
//                 el.addEventListener('keyup', function (e) {
//                     console.log(e.target.value.charAt(1));
//                     if (e.target.value.charAt(0) == '9') {
//                         var str = "8" + e.target.value;
//                         e.target.value = str;
//                     } else if (e.target.value.charAt(1) == '7') {
//                         var str = "8" + e.target.value.slice(2);
//                         e.target.value = str;
//                     } else if (e.target.value.charAt(0) != 8 && e.target.value.length == 1) {
//                         e.target.value = "8" + e.target.value;
//                     }
//                 })
//             });
//         }
//     },
//     change: function () {
//         var phone = document.querySelectorAll('.input[type="tel"]');
//         if (phone.length > 0) {
//             phone.forEach(function (el) {
//                 el.addEventListener('change', function (e) {
//                     if (e.target.value.charAt(0) != 8 && e.target.value.length > 1) {
//                         if (e.target.value.charAt(0) == '+') {
//                             var str = "8" + e.target.value.slice(2);
//                         } else if (e.target.value.charAt(0) == '9' && e.target.value.length == 10) {
//                             // автовставка на iphone
//                             var str = "8" + e.target.value;
//                         } else if (e.target.value.charAt(0) == '9') {
//                             var str = "8" + e.target.value;
//                         } else {
//                             var str = "8" + e.target.value.slice(1);
//                         }
//                         e.target.value = VMasker.toPattern(str, "9 (999) 999-99-99");
//                     }
//                 })
//             });
//         }

//     }
// }
// MG.phone.init();


// TODO home
MG.slide = {
    sliderIS: function () {
        if (!document.querySelector('.js-sliderIS')) return false;
        // var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        // if (width >= 990) return false;
        var sliderIS = new Swiper('.js-sliderIS', {
            loop: true,
            speed: 1000,
            slidesPerView: 1,
            spaceBetween: 16,
            // autoHeight: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 16
                },
                // 670: {
                //     slidesPerView: 2,
                //     spaceBetween: 16
                // },
                990: {
                    slidesPerView: 3,
                    spaceBetween: 16
                },
                1240: {
                    slidesPerView: 3,
                    spaceBetween: 16
                },
                1500: {
                    slidesPerView: 3,
                    spaceBetween: 32
                },
            },
            // effect: 'fade',
            // fadeEffect: {
            //     crossFade: true
            // },
            // preloadImages: false,
            // lazy: {
            //     loadPrevNext: true,
            //     elementClass: 'lazy',
            //     loadedClass: 'loaded'
            // },
            navigation: {
                nextEl: '.is__main .__next',
                prevEl: '.is__main .__prev',
            },
            // pagination: {
            //     el: ".js-progressbar",
            //     type: "progressbar",
            //     clickable: true
            // },
        });
        // sliderIS.autoplay.stop();
        // sliderIS.on('transitionStart', function () {
        //     var index = this.activeIndex + 1;
        //     document.querySelector('.js-current').innerHTML = '0' + index;
        // });

        return sliderIS;
    },
    sliderBar: function () {
        if (!document.querySelector('.js-sliderBar')) return false;
        // var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        // if (width >= 990) return false;
        var sliderBar = new Swiper('.js-sliderBar', {
            // loop: true,
            speed: 1000,
            slidesPerView: 1,
            spaceBetween: 16,
            // autoHeight: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            // breakpoints: {
            //     320: {
            //         slidesPerView: 1,
            //         spaceBetween: 16
            //     },
            //     670: {
            //         slidesPerView: 2,
            //         spaceBetween: 16
            //     },
            //     990: {
            //         slidesPerView: 3,
            //         spaceBetween: 16
            //     },
            //     1240: {
            //         slidesPerView: 3,
            //         spaceBetween: 16
            //     },
            //     1500: {
            //         slidesPerView: 3,
            //         spaceBetween: 32
            //     },
            // },
            // effect: 'fade',
            // fadeEffect: {
            //     crossFade: true
            // },
            // preloadImages: false,
            // lazy: {
            //     loadPrevNext: true,
            //     elementClass: 'lazy',
            //     loadedClass: 'loaded'
            // },
            // navigation: {
            //     nextEl: '.is__main .__next',
            //     prevEl: '.is__main .__prev',
            // },
            // pagination: {
            //     el: ".js-progressbar",
            //     type: "progressbar",
            //     clickable: true
            // },
            scrollbar: {
                el: ".swiper-scrollbar",
                draggable: true,
                // dragSize: document.body.clientWidth < 670 ? 115 : 250,
                dragSize: 115,
                hide: false,
                snapOnRelease: true
            },
        });
        // sliderBar.autoplay.stop();
        // sliderBar.on('transitionStart', function () {
        //     var index = this.activeIndex + 1;
        //     document.querySelector('.js-current').innerHTML = '0' + index;
        // });

        return sliderBar;
    },
}
if (MG.lighthouse.init()) {
    var sliderIS = MG.slide.sliderIS(),
        sliderBar = MG.slide.sliderBar();
    // beach__slide = MG.slide.beach__slide();
}


// TODO modal
MG.modal = {
    init: function () {
        this.open();
        this.close();
        this.key();
        this.send();
    },
    body: function () {
        return document.querySelector('body');
    },
    modals: function () {
        return document.querySelectorAll('.modal');
    },
    openElement: function () {
        return document.querySelectorAll('.js-modal');
    },
    closeElement: function () {
        return document.querySelectorAll('.js-modalClose');
    },
    open: function () {
        var body = this.body();
        this.openElement().forEach(function (el) {
            el.addEventListener('click', function (e) {
                e.preventDefault();

                var pos = getBodyScrollTop(),
                    scrollWidth = getScrollbarWidth();

                var id = this.getAttribute('href') || this.getAttribute('data-href'),
                    modal = document.querySelector(id),
                    isFixed = modal.classList.contains('fixed');

                if (!isFixed) {
                    body.style.position = "fixed";
                    if (scrollWidth > 0) {
                        body.style.overflowY = "scroll";
                    }
                    body.style.top = -pos + "px";
                }

                modal.style.display = "block";
                modal.offsetHeight;
                modal.setAttribute('open', '');
                modal.style.top = pos + "px";

                var html = document.querySelector('html');
                html.classList.remove('smooth');

                if (e.target.getAttribute('data-title')) {
                    var title = e.target.getAttribute('data-title'),
                        jsTitle = modal.querySelector('.js-title'),
                        jsTitleInput = modal.querySelector('.js-titleInput');
                    jsTitle ? jsTitle.innerHTML = title : '';
                    jsTitleInput ? jsTitleInput.value = title : '';
                }
                if (e.target.getAttribute('data-id')) {
                    var jsID = e.target.getAttribute('data-id'),
                        jsSelectInput = modal.querySelector('.js-selectInput'),
                        jsSelectedSelect = modal.querySelector('.js-selectedSelect');
                    jsSelectInput ? jsSelectInput.value = jsID : '';
                    jsSelectedSelect ? jsSelectedSelect.value = jsID : '';
                }
                if (e.target.getAttribute('data-value')) {
                    var value = e.target.getAttribute('data-value');
                    modal.querySelector('.js-modalValue').value = value;
                }
            });
        });
    },
    close: function () {
        var close = this.closeElement();
        close.forEach(function (el) {
            el.addEventListener('click', function (e) {
                e.preventDefault();
                MG.modal.closeFunc(e);
            });
        });
    },
    closeFunc: function (e) {
        var body = this.body(),
            pos = body.style.top,
            modal = e ? e.target.closest('.modal') : false;
        pos = parseInt(pos, 10) * -1;

        // console.log(e.target);

        if (modal) {
            modal.removeAttribute('open');
            setTimeout(function () {
                modal.style.display = "";
                modal.style.top = "";
            }, 300);

            var inputs = modal.querySelectorAll('.input_send');
            inputs.forEach(function (e) {
                e.value = '';
            });
        } else {
            this.modals().forEach(function (el) {
                el.removeAttribute('open');
                setTimeout(function () {
                    el.style.display = "";
                    el.style.top = "";
                }, 300);

                var inputs = el.querySelectorAll('.input_send');
                inputs.forEach(function (e) {
                    e.value = '';
                });
            });
        }

        var isSub = modal ? modal.classList.contains('__subModal') : false;
        if (!isSub) {
            body.style.position = "";
            body.style.overflowY = "";
            body.style.top = "";
            if (!isNaN(pos)) {
                var html = document.querySelector('html');
                window.scrollTo(0, pos);
                html.classList.add('smooth');
            }
        }
    },
    key: function () {
        window.addEventListener('keydown', function (e) {
            if ((e.key == 'Escape' || e.key == 'Esc' || e.which == 27 || e.keyCode == 27) && (document.querySelectorAll('.modal[open]').length > 0)) {
                e.preventDefault();
                MG.modal.closeFunc();
                return false;
            }
        }, true);
    },
    send: function () {
        $('.js-modalForm').on('submit', function (e) {
            e.preventDefault();

            var form = $(this),
                _this = this;

            MG.validate.search(_this, {
                'name': '3',
                'phone': '17',
            });

            if (_this.querySelectorAll('input.error').length > 0) {
                return false;
            }

            var msg = form.serialize();
            MG.message.processStart(_this);

            $.ajax({
                type: 'POST',
                // url: '/api/modal/',
                url: '/ajax.php',
                cache: false,
                data: msg,
                success: function (data) {
                    data = JSON.parse(data)

                    if (data.ok) {
                        MG.message.message(_this, data.msg, true);
                        MG.message.processEnd(_this);
                        MG.message.cleanInput(_this);
                        setTimeout(function () {
                            MG.modal.closeFunc();
                        }, 1500);

                        MG.modal.reachGoal('form');
                        return false;
                    }

                    if (data.error) {
                        MG.message.error(_this, data.msg);
                        MG.message.processEnd(_this);
                        return false;
                    }

                    if (data.bad) {
                        // MG.message.processEnd(_this);
                        // alert('Ошибка');

                        MG.message.message(_this, data.msg, true);
                        MG.message.processEnd(_this);
                        MG.message.cleanInput(_this);
                        setTimeout(function () {
                            MG.modal.closeFunc();
                        }, 1500);

                        MG.modal.reachGoal('form');
                        return false;
                    }

                },
                error: function (xhr, str) {
                    alert('Ошибка сервера: ' + xhr.responseCode);
                }
            });

            return false;
        });
    },
    reachGoal: function (goal) {
        if (typeof (ym) !== 'undefined') {
            ym(97774472, 'reachGoal', goal)
            console.log('goal ' + goal)
        } else {
            console.log('ym no')
        }
    }
}
MG.modal.init();


// MG.view = {
//     init: function () {
//         // this.food();
//         // this.inter();
//         // this.more();
//     },
// gallery: function () {
//     var view = document.querySelector('.gallery__wrap .js-gallery');
//     if (view) {
//         setTimeout(function () {
//             var viewBox = new SimpleLightbox('.gallery__wrap .js-gallery', {
//                 history: false,
//                 showCounter: false,
//                 fadeSpeed: 200,
//                 uniqueImages: false
//             });
//             // console.log(viewBox);
//         }, 300)
//     }
// },
// inter: function () {
//     var view = document.querySelector('.js-inter');
//     if (view) {
//         var viewBox = new SimpleLightbox('.js-inter', {
//             history: false,
//             showCounter: false,
//             sourceAttr: 'data-href',
//             fadeSpeed: 200
//         });
//     }
// },
// more: function () {
//     var btn = document.querySelector('.js-moreBtn'),
//         header = document.querySelector('.js-header');
//     if (btn) {
//         btn.addEventListener('click', function (e) {
//             e.preventDefault();

//             header.setAttribute('more', '');
//         });
//     }
// }
// }
// MG.view.init();


// var options = {
//     fullscreen: {
//         enabled: true,
//         iosNative: false
//     },
//     controls: [
//         "play-large",
//         "play",
//         "progress",
//         "duration",
//         "mute",
//         "volume",
//         "fullscreen"
//     ],
//     muted: true,
//     storage: { enabled: false }
// };
// var optionsIOS = {
//     ...options,
//     fullscreen: {
//         enabled: true,
//         iosNative: true
//     }
// };
// const player = new Plyr(document.querySelector(".plyr__wrap"), options);
// player.on('ready', (event) => {
//     setTimeout(() => {
//         player.media.pause();
//         isStart = false;
//     }, 100);
// });


MG.tools = {
    init: function () {
        // this.label();
        // this.startBg();
        // this.bg();
        // this.setTheme();
        // this.changeTheme();
        // this.next();
        // this.view();
        // this.viewBoxGastro();
        // this.openCategory();
        // this.openItem();
        // this.brandLine();
        this.more();
        this.tabs();
        this.services();
        // this.player(true);
        this.fixed();
        // this.counter();
        // this.calendarToggle();
        this.youtubeAPI();
        // this.customSelect();
        // this.objectMap();
        // this.tableSelect();
        this.docs();
        this.price();
        this.setPriceHeight();
        this.priceBlock();
        this.videoPlayer();
        this.filter();
        this.dropdown();
        this.more();
        this.faq();
    },
    faq: function () {
        const faq = document.querySelectorAll('.js-faq');
        faq.forEach(function (el) {
            el.addEventListener('click', function (e) {
                e.preventDefault();

                e.currentTarget.toggleAttribute('data-open');
            })
        })
    },
    more: function () {
        var btn = document.querySelectorAll('.js-more');
        btn.forEach(function (el) {
            el.addEventListener('click', function (e) {
                e.preventDefault();

                var wrap = e.target.closest('.js-moreWrap'),
                    list = wrap.querySelector('.js-moreList');

                if (list) list.setAttribute('data-open', '');
            })
        })
    },
    // setTheme: function () {
    //     let theme = localStorage.getItem('theme'),
    //         body = document.querySelector('body');

    //     let style = theme ? theme : 'theme__light';
    //     let current = style == 'theme__light' ? 'theme__dark' : 'theme__light';
    //     body.classList.replace(current, style);
    // },
    // changeTheme: function () {
    //     const items = document.querySelectorAll('.js-toggleTheme');
    //     items.forEach(function (el) {
    //         el.addEventListener('click', function (e) {
    //             e.preventDefault();

    //             let theme = e.target.getAttribute('data-theme');
    //             localStorage.setItem('theme', theme);
    //             MG.tools.setTheme();
    //         })
    //     });
    // },
    // label: function () {
    //     const labels = document.querySelectorAll('.js-label')

    //     labels.forEach(label => {
    //         label.innerHTML = label.innerText
    //             .split('')
    //             .map((letter, index) => `<span class="letter" style="transition-delay:${index * 50}ms">${letter}</span>`)
    //             .join('');
    //     })
    // },
    // next: true,
    // startBg: function () {
    //     const bg1 = document.querySelector('.js-headerItem.__1');
    //     if (!bg1) return;
    //     const bg2 = document.querySelector('.js-headerItem.__2');
    //     const bg3 = document.querySelector('.js-headerItem.__3');
    //     setTimeout(function () {
    //         if (MG.tools.next) {
    //             bg1.setAttribute('open', '');
    //         }
    //     }, 700);
    //     setTimeout(function () {
    //         if (MG.tools.next) {
    //             bg1.removeAttribute('open');
    //             bg3.setAttribute('open', '');
    //         }
    //     }, 1400);
    //     setTimeout(function () {
    //         if (MG.tools.next) {
    //             bg3.removeAttribute('open');
    //             bg2.setAttribute('open', '');
    //             MG.tools.s = false;
    //         }
    //     }, 2100);
    // },
    // bg: function () {
    //     const bg = document.querySelectorAll('.js-headerItem');

    //     bg.forEach(function (el) {
    //         el.addEventListener('touch', function (e) {
    //             e.preventDefault();

    //             bg.forEach(function (i) {
    //                 i.removeAttribute('open');
    //             });

    //             e.currentTarget.setAttribute('open', '');
    //             MG.tools.next = false;
    //         });
    //         el.addEventListener('click', function (e) {
    //             e.preventDefault();

    //             bg.forEach(function (i) {
    //                 i.removeAttribute('open');
    //             });

    //             e.currentTarget.setAttribute('open', '');
    //             MG.tools.next = false;
    //         });
    //         el.addEventListener('mouseover', function (e) {
    //             e.preventDefault();

    //             bg.forEach(function (i) {
    //                 i.removeAttribute('open');
    //             });

    //             e.currentTarget.setAttribute('open', '');
    //             MG.tools.next = false;
    //         });
    //     });
    // },
    // next: function () {
    //     var next = document.querySelectorAll('.js-next');
    //     next.forEach(function (el) {
    //         el.addEventListener('click', function (e) {
    //             // e.preventDefault();

    //             var btn = document.querySelector('.header .__next');
    //             btn.click();
    //         })
    //     })
    //     if (next) {
    //         next.addEventListener('click', function (e) {
    //             // e.preventDefault();

    //             var btn = document.querySelector('.header .__next');
    //             btn.click();
    //         })
    //     }
    // },
    // view: function () {
    //     var view = document.querySelectorAll('.js-view');
    //     if (view) {
    //         var viewBox = new SimpleLightbox('.section .js-view', { 'history': false, });
    //     }
    // },
    // viewBoxGastro: function () {
    //     var view = document.querySelectorAll('.js-viewBoxGastro');
    //     if (view) {
    //         var viewBox = new SimpleLightbox('.js-viewWrap .js-viewBoxGastro', { 'history': false, 'sourceAttr': 'data-href', rel: 'gastro' });
    //     }
    // },
    tabs: function () {
        var tabs = document.querySelectorAll('.js-tabSelect'),
            content = document.querySelectorAll('.js-tabCurrent');

        tabs.forEach(function (el) {
            el.addEventListener('click', function (e) {
                e.preventDefault();

                var id = e.target.getAttribute('id');
                if (!id) return;

                var current = document.querySelector('#' + id + '_current');
                if (!current) return;

                content.forEach(function (c) {
                    c.removeAttribute('open');
                })
                tabs.forEach(function (t) {
                    t.removeAttribute('open');
                })
                e.target.setAttribute('open', '');
                current.setAttribute('open', '');
            })
        })
    },
    services: function () {
        var select = document.querySelectorAll('.js-serviceSelect'),
            current = document.querySelectorAll('.js-serviceCurrent'),
            selected = document.querySelector('.js-serviceSelected');

        if (selected) {
            selected.addEventListener('click', function (el) {
                el.preventDefault();
                el.target.toggleAttribute('open');
            })
        }

        select.forEach(function (el) {
            el.addEventListener('click', function (e) {
                e.preventDefault();

                var id = e.target.getAttribute('data-id');
                if (!id) return;

                var node = document.querySelector('#' + id);
                if (!node) return;

                select.forEach(function (c) {
                    c.removeAttribute('open');
                })
                current.forEach(function (t) {
                    t.removeAttribute('open');
                })
                e.target.setAttribute('open', '');
                node.setAttribute('open', '');
                selected.innerHTML = e.target.innerHTML;
                selected.toggleAttribute('open');
            })
        })
    },
    // openCategory: function () {
    //     var open = document.querySelectorAll('.js-open'),
    //         isOpen = document.querySelectorAll('.price__item');
    //     open.forEach(function (el) {
    //         el.addEventListener('click', function (e) {
    //             e.preventDefault();

    //             isOpen.forEach(function (el) {
    //                 if (el != e.target.closest('.price__item')) {
    //                     el.removeAttribute('open');
    //                 }
    //             });

    //             e.target.closest('.price__item').toggleAttribute('open');

    //             // open.forEach(function (el) {
    //             //     el.removeAttribute('open');
    //             // });

    //             // var id = e.target.getAttribute('data-menu');
    //             // document.querySelectorAll('.' + id).forEach(function (el) {
    //             //     el.setAttribute('open', '');
    //             // });
    //             // e.target.setAttribute('open', '');
    //         });
    //     });
    // },
    // openItem: function () {
    //     var open = document.querySelectorAll('.js-openItem'),
    //         isOpen = document.querySelectorAll('.list__item');
    //     open.forEach(function (el) {
    //         el.addEventListener('click', function (e) {
    //             e.preventDefault();

    //             isOpen.forEach(function (el) {
    //                 if (el != e.target.closest('.list__item')) {
    //                     el.removeAttribute('open');
    //                 }
    //             });

    //             e.target.closest('.list__item').toggleAttribute('open');

    //             // open.forEach(function (el) {
    //             //     el.removeAttribute('open');
    //             // });

    //             // var id = e.target.getAttribute('data-menu');
    //             // document.querySelectorAll('.' + id).forEach(function (el) {
    //             //     el.setAttribute('open', '');
    //             // });
    //             // e.target.setAttribute('open', '');
    //         });
    //     });
    // },
    // player: function () {
    //     setTimeout(() => {
    //         player.media.play();
    //     }, 200);
    // },
    // brandLine: function () {
    //     const scrollers = document.querySelectorAll(".brand__anime");
    //     if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    //         addAnimation();
    //     }

    //     function addAnimation() {
    //         scrollers.forEach((scroller) => {
    //             scroller.setAttribute("data-animated", true);

    //             const scrollerInner = scroller.querySelector(".brand__anime--wrap");
    //             const scrollerContent = Array.from(scrollerInner.children);

    //             scrollerContent.forEach((item) => {
    //                 const duplicatedItem = item.cloneNode(true);
    //                 duplicatedItem.setAttribute("aria-hidden", true);
    //                 scrollerInner.appendChild(duplicatedItem);
    //             });
    //         });
    //     }
    // },
    more: function () {
        const more = document.querySelectorAll('.link__more');
        more.forEach(function (el) {
            el.addEventListener('click', function (e) {
                e.preventDefault();

                const id = e.target.getAttribute('href');
                if (id) document.querySelector(id).setAttribute('data-more', '');
            })
        })
    },
    fixed: function () {
        var header = document.querySelector('.js-header'),
            // content = document.getElementById('content'),
            // headerMain = document.querySelector('.js-headerMain'),
            sPosition = 0,
            ticking = false;

        function doSomething(position) {
            // if (document.body.clientWidth < 670) {
            var start = header ? header.clientHeight : 0;
            // if (position >= first) {
            //     header.classList.add('__top');
            //     headerMain ? '' : header.classList.add('fixed');
            // } else {
            //     header.classList.remove('__top');
            //     headerMain ? '' : header.classList.remove('fixed');
            // }
            // if (headerMain) {
            if (position >= start) {
                document.documentElement.style.setProperty('--header', "".concat(header.clientHeight, "px"));
                // content.classList.add('header__fixed')
                header.classList.add('fixed');
            } else {
                document.documentElement.style.setProperty('--header', "".concat(0, "px"));
                // content.classList.remove('header__fixed')
                header.classList.remove('fixed');
            }
            // } else {

            // }
            // }
        }

        window.addEventListener('scroll', function (e) {
            sPosition = window.scrollY;

            if (!ticking) {
                window.requestAnimationFrame(function () {
                    doSomething(sPosition);
                    ticking = false;
                });

                ticking = true;
            }
        });
    },
    // counter: function () {
    //     var plusMinus = document.querySelector('.js-plusMinus'),
    //         plus = document.querySelector('.js-plus'),
    //         minus = document.querySelector('.js-minus'),
    //         input = document.querySelector('.js-inputPlusMinus'),
    //         text = document.querySelector('.js-plusMinusText');

    //     if (plus) {
    //         plus.addEventListener('click', function (e) {
    //             e.preventDefault();

    //             var start = +input.value,
    //                 current = start + 1;
    //             input.value = current;
    //             plusMinus.innerHTML = current;
    //             text.innerHTML = MG.tools.wordEnd(current);
    //         })
    //     }
    //     if (minus) {
    //         minus.addEventListener('click', function (e) {
    //             e.preventDefault();

    //             var start = +input.value,
    //                 current = start > 1 ? start - 1 : 1;
    //             input.value = current;
    //             plusMinus.innerHTML = current;
    //             text.innerHTML = MG.tools.wordEnd(current);
    //         })
    //     }

    // },
    // calendarToggle: function () {
    //     var calendarDate = document.querySelectorAll('.js-calendarDate'),
    //         inputDate = document.querySelector('.js-inputDate');
    //     calendarDate.forEach(function (el) {
    //         el.addEventListener('click', function (e) {
    //             e.preventDefault();

    //             calendarDate.forEach(function (c) {
    //                 c.removeAttribute('open');
    //             });
    //             document.querySelector('.js-calendarIcon').removeAttribute('open');

    //             e.currentTarget.setAttribute('open', '');
    //             inputDate.value = e.currentTarget.getAttribute('data-date');
    //         })
    //     });
    // },
    youtubeAPI: function () {
        if (!MG.lighthouse.init()) return '';

        var tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    },
    youtube: function () {
        var youtube = document.querySelectorAll('.js-youtube');

        // var forEach = function (array, callback, scope) {
        //     for (var i = 0; i < array.length; i++) {
        //         callback.call(scope, i, array[i]);
        //     }
        // };

        youtube.forEach(function (el) {
            el.addEventListener('click', function (e) {
                e.preventDefault();

                var elem = e.target,
                    id = elem.getAttribute('data-youtube');
                //     iframe = document.createElement("iframe"),
                //     iframeURL = "https://www.youtube.com/embed/" + id + "?autoplay=1&autohide=1&mute=1&enablejsapi=1";
                // if (elem.getAttribute("data-params")) iframeURL += '&' + elem.getAttribute("data-params");
                // iframe.setAttribute("src", iframeURL);
                // iframe.setAttribute("frameborder", '0');
                // iframe.setAttribute("allow", 'autoplay');

                // console.log(elem.offsetWidth);
                // console.log(elem.offsetHeight);

                // iframe.setAttribute("width", elem.offsetWidth);
                // iframe.setAttribute("height", elem.offsetHeight);

                console.log(id);

                var player;
                player = new YT.Player(elem, {
                    height: elem.offsetHeight,
                    width: elem.offsetWidth,
                    videoId: id ? id : elem.getAttribute('data-id'),
                    playerVars: {
                        'playsinline': 1,
                        'controls': 0,
                        'modestbranding': 1,
                        'rel': 0
                    },
                    events: {
                        'onReady': onPlayerReady,
                        // 'onStateChange': onPlayerStateChange
                    }
                });
                function onPlayerReady(event) {
                    event.target.playVideo();
                }

                // elem.parentNode.replaceChild(iframe, this);
                // elem.append(iframe)
            })
        })
    },
    // customSelect: function () {
    //     var select = document.querySelectorAll('.js-selectCustom');
    //     select.forEach(function (el) {
    //         el.addEventListener('click', function (e) {
    //             e.preventDefault();
    //             var selectOpen = document.querySelectorAll('.js-selectCustom[open]');

    //             if (el == e.target) {
    //                 e.target.toggleAttribute('open');
    //                 selectOpen.forEach(atr => atr.removeAttribute('open'));
    //             }
    //         })

    //     });
    //     document.addEventListener('click', function (e) {
    //         var open = document.querySelectorAll('.js-selectCustom[open]');
    //         if (open.length) {
    //             var target = e.target,
    //                 list = document.querySelector('.select__custom .current__wrap[open]+.list'),
    //                 isList = target == list || list.contains(target);

    //             if (!isList && !target.classList.contains('js-selectCustom')) {
    //                 var selectOpen = document.querySelectorAll('.js-selectCustom[open]');
    //                 selectOpen.forEach(atr => atr.removeAttribute('open'));
    //             }
    //         }
    //     });
    // },
    // objectMap: function () {
    //     var open = document.querySelector('.js-toMap');
    //     if (!open) return false;

    //     open.addEventListener('click', function (el) {
    //         el.preventDefault();

    //         var isMap = document.querySelector('.js-isMap'),
    //             header = document.querySelector('.js-header');
    //         isMap.setAttribute('open', '');

    //         var pos = isMap.offsetTop + header.offsetHeight;
    //         // var рeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    //         skrollTop.scrollTo({
    //             to: pos - 40,
    //             duration: 500
    //         });
    //     })
    // },
    // calendarApply: function (date) {
    //     if (!date) return false;

    //     document.querySelector('.js-inputDate').value = date;
    //     document.querySelector('.js-calendarText').innerHTML = parseInt(date.split('.')[0]);

    //     document.querySelector('.js-calendarIcon').setAttribute('open', '');

    //     var calendarDate = document.querySelectorAll('.js-calendarDate');
    //     calendarDate.forEach(function (e) {
    //         e.removeAttribute('open');
    //     })
    // },
    // tableScale: function () {
    //     const plus = document.querySelector('.js-scalePlus'),
    //         minus = document.querySelector('.js-scaleMinus'),
    //         table = document.querySelector('.js-tableScroll'),
    //         svg = document.querySelector('.table__svg');

    //     let width = 0,
    //         current = 1;

    //     setTimeout(() => {
    //         table.style.height = table.offsetHeight + 'px';
    //         width = table.offsetWidth;
    //     }, 300);

    //     plus.addEventListener('click', function (e) {
    //         e.preventDefault();

    //         if (!width) return;

    //         current = current + 0.5;
    //         svg.style.width = (width * current) + 'px';
    //     })
    //     minus.addEventListener('click', function (e) {
    //         e.preventDefault();

    //         if (!width) return;

    //         current = current > 1 ? current - 0.5 : 1;
    //         svg.style.width = (width * current) + 'px';
    //     })
    // },
    // tableSelect: function () {
    //     let table = document.querySelectorAll('.js-tableNum'),
    //         input = document.querySelector('.js-inputTable'),
    //         text = document.querySelector('.js-tableSelectedText');

    //     table.forEach(function (el) {
    //         el.addEventListener('click', function (e) {
    //             e.preventDefault();

    //             table.forEach(function (t) {
    //                 t.removeAttribute('open');
    //             })

    //             e.target.setAttribute('open', '');
    //             input.value = e.target.getAttribute('data-num');
    //             text.innerHTML = 'Стол №' + input.value;
    //         })
    //     });
    // },
    // wordEnd: function (value) {
    //     value = Math.abs(value) % 100;
    //     var num = value % 10,
    //         words = ['гость', 'гостя', 'гостей'];
    //     if (value > 10 && value < 20) return words[2];
    //     if (num > 1 && num < 5) return words[1];
    //     if (num == 1) return words[0];
    //     return words[2];
    // },
    docs: function () {
        var items = document.querySelectorAll('.js-openDocs');
        items.forEach(function (el) {
            el.addEventListener('click', function (e) {
                e.preventDefault();

                // items.forEach(function (i) {
                //     i.closest('.item__documents').removeAttribute('data-open');
                // })

                var wrap = e.currentTarget.closest('.item__documents');
                wrap.toggleAttribute('data-open');
            })
        })
    },
    price: function () {
        var items = document.querySelectorAll('.js-priceItem');
        items.forEach(function (el) {
            el.addEventListener('click', function (e) {
                e.preventDefault();


                var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
                if (width >= 670) {
                    items.forEach(function (i) {
                        i.closest('.item__price--wrap').removeAttribute('data-open');
                    })
                }

                var wrap = e.currentTarget.closest('.item__price--wrap');
                if (width >= 670) {
                    wrap.setAttribute('data-open', '');

                    setTimeout(function () {
                        var content = wrap.querySelector('.item__price--content'),
                            min = content.offsetHeight;

                        var list = document.querySelector('.list__price');
                        list.style.minHeight = min + 'px';
                    }, 200)
                } else {
                    wrap.toggleAttribute('data-open');
                }

            })
        })
    },
    setPriceHeight: function () {
        var wrap = document.querySelector('.item__price--wrap[data-open]'),
            width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        if (wrap && width >= 670) {
            var content = wrap.querySelector('.item__price--content'),
                min = content.offsetHeight,
                list = document.querySelector('.list__price');
            list.style.minHeight = min + 'px';
        }
    },
    priceBlock: function () {
        var cat = document.querySelectorAll('.js-priceCategory');
        cat.forEach(function (el) {
            el.addEventListener('click', function (e) {
                e.preventDefault();

                var id = e.target.getAttribute('data-id'),
                    sec = document.querySelectorAll('.js-priceSections'),
                    currnet = document.querySelector('.js-priceSections[data-section="' + id + '"]');

                sec.forEach(function (s) {
                    s.removeAttribute('data-open');
                })
                currnet.setAttribute('data-open', '');

                cat.forEach(function (c) {
                    c.removeAttribute('data-open');
                })
                e.currentTarget.setAttribute('data-open', '');
            })
        })

        var section = document.querySelectorAll('.js-section');
        section.forEach(function (el) {
            el.addEventListener('click', function (e) {
                e.preventDefault();

                e.target.closest('.price__section').toggleAttribute('data-open');
            })
        })
    },
    videoPlayer: function () {
        var video = document.querySelectorAll('.js-player'),
            source = document.querySelectorAll('.js-player source');
        source.forEach(function (el) {
            var src = el.getAttribute('data-src');
            el.setAttribute('src', src);

            el.removeAttribute('data-src');
        });

        var players = Array.from(video).map(function (p) {
            return new Plyr(p, {
                controls: ['play-large'],
            });
        });
    },
    filter: function () {
        var select = document.querySelector('.js-filterSelect');
        if (select) {
            select.addEventListener('change', function (el) {
                var id = el.target.value,
                    items = document.querySelectorAll('.js-filterItem');

                items.forEach(function (e) {
                    if (id == '--') {
                        e.removeAttribute('data-hidden');
                        return '';
                    }

                    var item = e.getAttribute('data-id');
                    if (item == id) {
                        e.removeAttribute('data-hidden');
                    } else {
                        e.setAttribute('data-hidden', '');
                    }
                })
            })
        }
    },
    dropdown: function () {
        var dropdown = document.querySelectorAll('.js-dropdownState');
        dropdown.forEach(function (el) {
            el.addEventListener('click', function (e) {
                e.preventDefault();

                var node = e.target.closest('.js-dropdown');
                if (node) node.toggleAttribute('data-open');
            })
        })
    }
}
MG.tools.init();
if (MG.lighthouse.init()) {
    function onYouTubeIframeAPIReady() { // активирует после инициализации API
        MG.tools.youtube();
    }
}


// TODO Map
MG.map = {
    init: function () {
        // this.src(4000);
    },
    src: function (time) {
        if (MG.lighthouse.init()) {
            var elem = document.createElement('script');
            elem.src = '//api-maps.yandex.ru/2.1/?lang=ru-RU&onload=MG.map.getYaMap';
            document.getElementsByTagName('body')[0].appendChild(elem);
        }
    },
    getYaMap: function () {
        ymaps.ready(MG.map.create);
    },
    create: function () {
        var map = new ymaps.Map('map', {
            center: [org.y, org.x],
            zoom: 14,
            controls: []
        }, {
            // searchControlProvider: 'yandex#search'
        }),
            // MyIconContentLayout = ymaps.templateLayoutFactory.createClass(
            //     '<div class="map_view">$[properties.iconContent]</div>'
            // ),
            p_1 = new ymaps.Placemark([org.y, org.x], {
                balloonContent: '<div>' +
                    '<div class="bold"><b>' + org.name + '</b></div>' +
                    '<address>' + org.address + '</address>' +
                    '<div class="bold"><a href="tel:' + org.phone + '">' + org.phone + '</a></div></div>'
            }, {
                iconLayout: 'default#image',
                iconImageHref: org.icon,
                iconImageSize: [org.width, org.height],
                iconImageOffset: [-org.width / 2, -org.height],
                balloonPanelMaxMapArea: 0,
                closeButton: false
            });

        map.geoObjects.add(p_1);
    },
    // object: function () {
    //     if (MG.lighthouse.init()) {
    //         var elem = document.createElement('script');
    //         elem.src = '//api-maps.yandex.ru/2.1/?lang=ru-RU&onload=MG.map.getObject';
    //         document.getElementsByTagName('body')[0].appendChild(elem);
    //     }

    // },
    // getObject: function () {
    //     ymaps.ready(MG.map.createObject);
    // },
    // createObject: function () {
    //     var map = new ymaps.Map('map_object', {
    //         center: [mapObject.y, mapObject.x],
    //         zoom: 14,
    //     }, {
    //         searchControlProvider: 'yandex#search'
    //     }),
    //         p_1 = new ymaps.Placemark([mapObject.y, mapObject.x], {
    //             balloonContent: '<div>' +
    //                 '<div class="bold"><b>«' + org.name + '»</b></div>' +
    //                 '<div><a href="tel:' + org.phone + '">' + org.phone + '</a></div></div>'
    //         }, {
    //             iconLayout: 'default#image',
    //             iconImageHref: org.icon,
    //             iconImageSize: [24, 36],
    //             iconImageOffset: [-12, -36],
    //             balloonPanelMaxMapArea: 0,
    //             closeButton: false
    //         });

    //     map.geoObjects.add(p_1);
    // },
    // list: function () {
    //     if (MG.lighthouse.init()) {
    //         var elem = document.createElement('script');
    //         elem.src = '//api-maps.yandex.ru/2.1/?lang=ru-RU&onload=MG.map.getList';
    //         document.getElementsByTagName('body')[0].appendChild(elem);
    //     }
    // },
    // getList: function () {
    //     ymaps.ready(initObjectList);
    // },
}
MG.map.init();


MG.lazyload = {
    init: function (func) {
        // console.log(func)
        switch (func) {
            case 'MG.map.src':
                MG.map.src();
                break;

            // case 'MG.tools.player':
            //     MG.tools.player();
            //     break;

            // case 'MG.tools.youtubeAPI':
            //     MG.tools.youtubeAPI();
            //     break;

            // case 'MG.view.gallery':
            //     MG.view.gallery();
            //     break;

            default:
                console.log("Func not found");
                break;
        }
    }
}


// TODO календарь
// var calendars = ['.js-calendar'];
// // openCalendar = document.querySelectorAll('.js-openCalendar'),
// // closeCalendar = document.querySelectorAll('.js-closeCalendar');
// calendars.forEach(function (el) {
//     new VanillaCalendar({
//         selector: el,
//         months: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
//         shortWeekday: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
//         onSelect: (data, elem) => {

//             document.querySelector(el).closest('.__calendar').querySelector('.btn').setAttribute('onclick', 'MG.tools.calendarApply("' + data.date + '")');

//             // document.querySelector(el).closest('.label__wrap').querySelector('.js-inputCalendar').value = data.date;
//             // document.querySelector('.js-inputDate').value = data.date;
//             // document.querySelector('.js-calendarText').innerHTML = parseInt(data.date.split('.')[0]);

//             // document.querySelector('.js-calendarIcon').setAttribute('open', '');

//             // var calendarDate = document.querySelectorAll('.js-calendarDate');
//             // calendarDate.forEach(function (e) {
//             //     e.removeAttribute('open');
//             // })

//             // var modalCalendar = document.querySelector('#modalCalendar');
//             // if (modalCalendar) {
//             //     modalCalendar.removeAttribute('open');
//             //     modalCalendar.style.display = "";
//             //     modalCalendar.style.top = "";
//             // }
//         }
//     })
// });
// openCalendar.forEach(function (el) {
//     el.addEventListener('focus', function (e) {
//         e.target.closest('.label__wrap').querySelector('.vanilla-calendar').setAttribute('open', '');
//     });
// });
// closeCalendar.forEach(function (el) {
//     el.addEventListener('click', function (e) {
//         e.target.closest('.label__wrap').querySelector('.vanilla-calendar').removeAttribute('open');
//     });
// });


// var parallaxElements = document.querySelectorAll('.js-parallax')
// var parallax = elements => {
//     if ('undefined' !== elements && elements.length > 0) {
//         elements.forEach(element => {
//             let y = window.innerHeight - element.getBoundingClientRect().top
//             if (y > 0) {
//                 var orient = element.getAttribute('data-orient');
//                 if (orient == 'down') {
//                     element.style.transform = 'translate3d(0, +' + (0.08 * y) + 'px ,0)'
//                 } else {
//                     element.style.transform = 'translate3d(0, -' + (0.08 * y) + 'px ,0)'
//                 }
//             }
//         })
//     }
// }
// parallax(parallaxElements)
// window.onscroll = () => {
//     parallax(parallaxElements)
// }

// var animateButton = function (e) {
//     // e.preventDefault();
//     e.target.classList.remove('animate__btn');

//     e.target.classList.add('animate__btn');
//     setTimeout(function () {
//         e.target.classList.remove('animate__btn');
//     }, 700);
// };
// var jsButton = document.querySelectorAll(".js-btn");
// for (var i = 0; i < jsButton.length; i++) {
//     jsButton[i].addEventListener('click', animateButton, false);
// }


// var Scrollbar = window.Scrollbar;
// document.querySelectorAll('.js-scrollWrap').forEach(function (el) {
//     Scrollbar.init(el, { alwaysShowTracks: true });
// })

// Событие для слайдер dish__slider
// window.addEventListener('nextSlider', (e) => {
//     // const { target, way, from } = e.detail;
//     // console.log(`target: ${target}`, `way: ${way}`, `from: ${from}`);
//     setTimeout(function () {
//         dish__slider.slideNext();
//     }, 1000)
// });

// const timeScrollbar = window.Scrollbar;
// document.querySelectorAll('.js-timeScroll').forEach(function (el) {
//     var tc = timeScrollbar.init(el, { alwaysShowTracks: false }),
//         prev = document.querySelector('.__widget .__prev'),
//         next = document.querySelector('.__widget .__next'),
//         currentX;

//     prev.addEventListener('click', scrollIt, false);
//     next.addEventListener('click', scrollIt, false);

//     function scrollIt(e) {
//         currentX = tc.offset.x;
//         x = e.currentTarget.classList.contains('__prev') ? currentX - (81 * 2) : currentX + (81 * 2);
//         y = tc.offset.y;
//         tc.setPosition(x, y);
//     }
// })
// const tableScrollbar = window.Scrollbar;
// document.querySelectorAll('.js-tableScroll').forEach(function (el) {
//     var sc = tableScrollbar.init(el, { alwaysShowTracks: false });

//     var object = document.querySelector('.table__svg--wrap'),
//         initX, initY, currentX, currentY;

//     object.addEventListener('mousedown', function (e) {
//         e.preventDefault();

//         initX = e.pageX;
//         initY = e.pageY;
//         currentX = sc.offset.x;
//         currentY = sc.offset.y;

//         this.addEventListener('mousemove', dragIt, false);

//         window.addEventListener('mouseup', function () {
//             object.removeEventListener('mousemove', dragIt, false);
//         }, false);

//     }, false);

//     function dragIt(e) {
//         x = currentX - (e.pageX - initX) * 1;
//         y = currentY - (e.pageY - initY) * 1;
//         sc.setPosition(x, y);
//     }

// })
// const modalScrollbar = window.Scrollbar;
// document.querySelectorAll('.js-modalScroll').forEach(function (el) {
//     modalScrollbar.init(el, { alwaysShowTracks: false });
// })
// const navScrollbar = window.Scrollbar;
// document.querySelectorAll('.js-navScroll').forEach(function (el) {
//     navScrollbar.init(el, { alwaysShowTracks: false });
// })


PROBA.video = {
    init: function () {
        this.video();
        this.playByTouch();
    },
    video: function () {
        // var srcVideo = {
        //     0: '/img/pc.mp4',
        //     670: '/img/mb.mp4'
        // };
        var video = document.querySelector('.js-video'),
            play = document.querySelector('.js-play');
        if (video) {
            var mediaQuery = '(min-width: 670px)',
                mediaQueryList = window.matchMedia(mediaQuery),
                source = document.createElement('source');

            source.setAttribute('type', 'video/mp4');
            video.appendChild(source);

            if (mediaQueryList.matches) {
                source.setAttribute('src', srcVideo[0]);
            }
            else {
                source.setAttribute('src', srcVideo[670]);
            }

            mediaQueryList.addEventListener('change', event => {
                if (event.matches) {
                    source.setAttribute('src', srcVideo[0]);
                } else {
                    source.setAttribute('src', srcVideo[670]);
                }
            })

            video.addEventListener("playing", function () {
                play.style.display = 'none';
            });

        }
    },
    playByTouch: function () {
        var video = document.querySelector('.js-video'),
            play = document.querySelector('.js-play'),
            start = false;
        document.addEventListener('touchstart', function () {
            if (video && !start) {
                var promise = video.play();

                if (promise !== undefined) {
                    promise.then(_ => {
                        play.style.display = 'none';
                    }).catch(error => {
                        console.log('Кнопка есть');
                    });
                }

                start = true;
                // document.removeEventListener('click', musicPlay);
            }
        });
    },
}
PROBA.video.init();


// MG.before = {
//     init: function () {
//         this.each();
//     },
//     each: function () {
//         var before = document.querySelectorAll('.js-example');
//         before.forEach(function (e, i) {
//             e.classList.add('js-example-' + i);
//             var current = '.js-example-' + i;
//             new BeerSlider(e, { start: 30 });
//         })
//     }
// }
// MG.before.init();


const customScrollbar = window.Scrollbar;
document.querySelectorAll('.js-customScrollbar').forEach(function (el) {
    customScrollbar.init(el, { alwaysShowTracks: true });
})